import { KatapultElement, html } from '../../mixins/katapult-element.js';

import './katapult-assessment-editor';
import './katapult-attribute-editor';
import './katapult-attribute-sets-editor';
import './katapult-tool-editor';
import './katapult-toolset-editor';
import './katapult-clearance-editor';
import './katapult-routine-editor';
import './katapult-photo-element-editor.js';
import './katapult-photo-toolset-editor';
import './katapult-photo-form-editor';
import './katapult-map-print-template-editor';
import './katapult-saved-view-template-editor';
import './katapult-configurable-export-editor';
import './katapult-web-automations-editor';
import './katapult-files-editor';
import './katapult-reference-layer-editor.js';
import './katapult-api-layer-editor.js';
import './katapult-custom-icons-editor.js';
import './katapult-custom-line-styles-editor.js';
import './katapult-quality-control-editor.js';
import './katapult-custom-line-styles-editor.js';
import './katapult-project-editor.js';
import './katapult-portal-app-type-editor.js';
import './katapult-portal-display-options-editor.js';
import './katapult-portal-user-options-editor.js';
import './katapult-model-options-editor.js';
import './katapult-catalog-importer.js';
import './katapult-hub-application-configuration-editor.js';
import './katapult-default-spec-editor.js';
import './katapult-pole-spec-editor.js';
import './katapult-wire-spec-editor.js';
import './katapult-anchor-spec-editor.js';
import './katapult-insulator-spec-editor.js';
import './katapult-arm-spec-editor.js';
import './katapult-equipment-spec-editor.js';
import './katapult-sidewalk-brace-spec-editor.js';
import './katapult-pushbrace-spec-editor.js';
import './katapult-cross-server-model-space-sharing.js';
import './katapult-proposed-logic-editor.js';
import './katapult-compatible-unit-editor.js';
import './katapult-make-ready-notification-editor.js';
import './katapult-virtual-rideout-editor.js';
import './katapult-dds-bundle-editor.js';
import './katapult-load-case-editor.js';
import './katapult-compatible-unit-automations-editor.js';
import './katapult-mobile-options-editor.js';
import { AnimationManager } from './animationManager.js';
import { LazySet } from '../../modules/LazySet.js';
import { DefaultStyle } from './katapult-model-editor-style.js';
import { FormatSize } from '../../modules/FormatSize.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { NameToKey } from '../../modules/NameToKey';
import { CamelCase } from '../../modules/CamelCase.js';
import { Path } from '../../modules/Path.js';
import { IllegalCharacters, ContainsIllegalCharacters } from '../../modules/ContainsIllegalCharacters.js';
import { FormatDate } from '../../modules/Date';
import { ToArray } from '../../modules/ToArray.js';
import { LargeUpdate } from '../../modules/LargeUpdate.js';
import { FirebaseEncode } from '../../modules/FirebaseEncode.js';
import '../katapult-elements/katapult-button.js';
import { KatapultEditorTemplate } from './katapult-editor-template.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import '../katapult-elements/katapult-icon.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import pluralize from 'pluralize-esm';
import './tags/model-item-tag.js';
import { DEFAULT_TAGS, DEFAULT_ITEM_TAG_MAP, DEFAULT_CATEGORY_TAG_MAP } from './tags/DefaultTags.js';

class KatapultModelEditorWorkspace extends KatapultElement {
  static get template() {
    return html`
      ${DefaultStyle}
      <style include="katapult-scrollbars paper-dialog-style paper-table-style paper-tooltip-style">
        :host {
          position: relative;
          display: flex;
          flex-direction: column;
          /* padding: 48px;
            padding-top: 24px;           */
          background: var(--paper-grey-50);
          flex-grow: 1;

          --paper-input-container-underline: {
            border-color: rgba(0, 0, 0, 0.1);
          };
        }
        #workspaceHeader {
          display: flex;
          align-items: center;
          height: 48px;
          color: var(--paper-grey-600);

          margin: 24px 48px;

          margin-bottom: 24px;
        }
        #workspaceHeader katapult-button,
        #workspaceHeader katapult-button::not([secondary-color]) {
          color: var(--paper-grey-600);
        }
        #workspaceTitle {
          flex-grow: 1;
          --primary-color: var(--secondary-color);
          --katapult-animated-text-label: {
            font-weight: 500;
            font-size: 24pt;
            color: var(--paper-grey-600);
          };
        }
        #editingContainer {
          background: white;
          border-radius: 16px;
          border: 1px solid var(--paper-grey-200);
        }
        #workspaceContainer {
          position: relative;
          flex-grow: 1;
          margin: 48px;
          margin-top: 0;
        }
        #listFilter {
          margin-top: 66px;
          white-space: nowrap;
        }
        .workspaceView {
          position: absolute;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
        #listLayoutWrapper {
          display: flex;
          height: inherit;
        }
        #listLayoutWrapper > div {
          margin: 12px;
        }
        #sideContainer {
          position: relative;
        }
        #sideContainer > div {
          position: absolute;
          right: 0;
        }
        .listContainer {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .listContainer > *:not(:last-child) {
          margin-bottom: 16px;
        }
        .listHeader,
        #newItemNameInputContainer {
          display: flex;
          align-items: center;
        }
        .listHeader {
          height: 56px;
        }
        .listHeader > paper-table {
          height: 100%;
          justify-content: center;
        }
        paper-checkbox,
        paper-input {
          --primary-color: var(--secondary-color);
        }
        paper-cell[icon] > paper-checkbox {
          --paper-checkbox-unchecked-color: var(--paper-grey-600);
        }
        paper-table {
          color: var(--paper-grey-600);
        }
        highlight-text {
          display: flex;
          width: -webkit-fill-available;
          white-space: nowrap;
          --filter: {
            color: var(--paper-grey-600);
          };
          --match: {
            color: var(--primary-text-color);
          };
          --highlight: {
            background-color: var(--secondary-color);
            color: var(--secondary-color-text-color);
            padding: 0px 2px;
            border-radius: 4px;
          };
        }
        [column] {
          flex-direction: column;
        }
        .overlay {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background: rgba(255, 255, 255, 0.6);
          z-index: 1;
          box-sizing: border-box;
        }

        katapult-model-editor-workspace {
          border-radius: 24px;
          @apply --shadow-elevation-8dp;
        }

        #headerButtonsContainer {
          position: relative;
          height: inherit;
          flex-grow: 1;
          white-space: nowrap;
        }

        #headerButtonsContainer > div {
          position: absolute;
          right: 0;
          top: 0;
        }

        paper-row[selected] {
          background: var(--secondary-color);
          color: var(--secondary-color-text-color);
        }

        #itemContextMenu {
          position: fixed;
          opacity: 0;
          pointer-events: none;
          top: 0;
          left: 0;
          z-index: 999;
          overflow: hidden;
          @apply --shadow-elevation-8dp;
        }

        #itemContextMenu paper-row:hover {
          background: var(--secondary-color);
          color: var(--secondary-color-text-color);
        }

        s-circle-progress {
          margin: 0;
          flex-shrink: 0;
          height: 100%;
          --s-circle-progress-transition: stroke-dashoffset 0;
          --s-circle-progress-stroke-color: var(--secondary-color);
        }

        .colorBox {
          height: 24px;
          width: 24px;
          margin: 8px;
          box-shadow: var(--shadow-elevation-2dp_-_box-shadow);
          border-radius: 4px;
          box-sizing: border-box;
        }

        .helpTooltip {
          max-width: 300px;
          --paper-tooltip_-_text-transform: none;
          --paper-tooltip_-_text-align: left;
          --paper-tooltip_-_padding: 0.6em 1em;
          --paper-tooltip_-_font-size: 11pt;
          --paper-tooltip_-_border-radius: 24px;
        }

        .catalog-description-container {
          background-color: white;
          border-radius: 16px;
          border: 1px solid rgba(0 0 0 / 6%);
          display: flex;
          flex-direction: column;
          padding: 12px;
          gap: 12px;
        }
        .tags {
          display: flex;
          flex-wrap: wrap;
          gap: var(--sl-spacing-x-small);
          padding: var(--sl-spacing-x-small);
          justify-content: flex-end;
        }
        #listSearchContainer {
          gap: var(--sl-spacing-small);
        }
      </style>

      <katapult-firebase-worker
        id="catalogsDataFirebaseWorker"
        path="photoheight/catalogs"
        loading="{{catalogsDataLoading}}"
        data="{{catalogsData}}"
      >
      </katapult-firebase-worker>

      <katapult-firebase-worker
        id="modelOptionsFirebaseWorker"
        path="photoheight/company_space/[[userGroup]]/model_options"
        data="{{modelOptions}}"
        loading="{{modelOptionsLoading}}"
      >
      </katapult-firebase-worker>

      <katapult-firebase-worker
        id="catalogDataFirebaseWorker"
        path="[[catalogDataPath]]"
        loading="{{catalogDataLoading}}"
        data="{{catalogData}}"
      >
      </katapult-firebase-worker>

      <katapult-firebase-worker
        id="catalogCategoryModelSpaceDataFirebaseWorker"
        path="[[catalogCategoryModelSpaceDataPath]]"
        loading="{{catalogCategoryModelSpaceDataLoading}}"
        data="{{catalogCategoryModelSpaceData}}"
      >
      </katapult-firebase-worker>

      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/input_models" data="{{inputModels}}"> </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/tags" data="{{modelTags}}"> </katapult-firebase-worker>

      <paper-table id="itemContextMenu" on-click="closeItemContextMenu" white rounded dividers>
        <paper-row pointer on-click="renameItem">
          <paper-cell icon>
            <iron-icon icon="editor:title"></iron-icon>
          </paper-cell>
          <paper-cell>Rename</paper-cell>
        </paper-row>
        <template is="dom-if" if="[[showCopyButton(category)]]">
          <paper-row pointer on-click="copyItem">
            <paper-cell icon>
              <iron-icon icon="content-copy"></iron-icon>
            </paper-cell>
            <paper-cell>Copy</paper-cell>
          </paper-row>
        </template>
        <template is="dom-if" if="[[equal(category, 'files')]]">
          <paper-row pointer on-click="downloadItem">
            <paper-cell icon>
              <iron-icon icon="file-download"></iron-icon>
            </paper-cell>
            <paper-cell>Download</paper-cell>
          </paper-row>
        </template>
        <template is="dom-if" if="[[equal(userGroup, 'katapult')]]">
          <a target="_blank" style="color: inherit; text-decoration:none;" href$="[[selectedItemDataFirebaseUrl]]">
            <paper-row pointer divider>
              <paper-cell icon>
                <iron-icon icon="link"></iron-icon>
              </paper-cell>
              <paper-cell>View Firebase Record</paper-cell>
            </paper-row>
          </a>
        </template>
        <paper-row pointer on-click="deleteItem">
          <paper-cell icon>
            <iron-icon icon="delete"></iron-icon>
          </paper-cell>
          <paper-cell>Delete</paper-cell>
        </paper-row>
      </paper-table>

      <template is="dom-if" if="[[!hasParentWorkspace]]" restamp on-dom-change="setupCatalogImporter">
        <katapult-catalog-importer id="catalogImporter" model-space="[[modelSpace]]" model-space-options="[[modelSpaceOptions]]">
        </katapult-catalog-importer>
      </template>

      <template is="dom-if" if="[[showSubWorkspace]]" restamp on-dom-change="subWorkspaceDomChange">
        <div id="subWorkspaceOverlay" style="padding: 64px; justify-content: unset; align-items: unset;" class="overlay">
          <katapult-model-editor-workspace
            id="workspace"
            style="transform: translateY(48px); opacity: 0; transition: transform 0.3s;"
            user-group="[[userGroup]]"
            model-space="[[modelSpace]]"
            has-parent-workspace
            on-saved-item="subWorkspaceSavedItem"
            on-close-request="closeSubWorkspace"
            user-company-name="[[userCompanyName]]"
          >
          </katapult-model-editor-workspace>
        </div>
      </template>

      <paper-dialog
        id="confirmAddCatalogToModelSpaceDialog"
        fit-into="[[$.editingContainer]]"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
      >
        <div title style="background-color: var(--error-color); color: white;">
          <iron-icon icon="[[selectedCatalog.icon]]"></iron-icon>
          <span>
            <span>Import [[selectedCatalog.type]]</span>
            <template is="dom-if" if="[[catalogCategoryToAddDetails]]">
              <span> [[catalogCategoryToAddDetails.title]]</span>
            </template>
          </span>
        </div>
        <div body>
          <div>
            <span>Are you sure that you want to import the </span>
            <span>
              <b>
                <span>[[selectedCatalog.label]] [[selectedCatalog.type]]</span>
                <template is="dom-if" if="[[catalogCategoryToAddDetails]]">
                  <span> [[catalogCategoryToAddDetails.title]]</span>
                </template>
              </b>
            </span>
            <span> into the <b>[[modelSpaceDetails.label]] Model</b></span>
            <div>Doing so may overwrite any items that exist in both places</div>
          </div>
        </div>
        <div buttons>
          <katapult-button style="margin-right: 8px;" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--error-color)" on-click="importFromCatalog" loading="[[selectedCatalog.$adding]]"
            >Confirm</katapult-button
          >
        </div>
      </paper-dialog>

      <paper-dialog
        id="renameItemDialog"
        fit-into="[[$.editingContainer]]"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        opened="{{renameItemDialogOpened}}"
      >
        <div title secondary-color>
          <iron-icon icon="editor:title"></iron-icon>
          <span>Rename [[itemTypeTitles.title]]</span>
        </div>
        <div body>
          <paper-input
            value="[[selectedItemTitle]]"
            label="[[itemTypeTitles.title]] Name"
            error-message="[[itemLabelErrorMessage]]"
            invalid="[[itemLabelErrorMessage]]"
            on-value-changed="itemLabelInputChanged"
          ></paper-input>
        </div>
        <div buttons>
          <katapult-button on-click="cancelRenameItem">Cancel</katapult-button>
          <div style="flex-grow: 1;"></div>
          <katapult-button
            color="var(--secondary-color)"
            loading="[[savingSelectedItem]]"
            on-click="confirmRenameItem"
            disabled="[[!canSaveItem]]"
            >Save</katapult-button
          >
        </div>
      </paper-dialog>

      <paper-dialog
        id="externalChangesDialog"
        fit-into="[[$.editingContainer]]"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
      >
        <div title amber>Changed By Someone Else</div>
        <div body style="text-align: center;">
          <div>[[selectedItemTitle]] has been modified by someone else</div>
          <div>You may still save your changes, however, you may overwrite their changes in doing so</div>
        </div>
        <div buttons>
          <katapult-button on-click="externalChangesButtonClicked">Cancel</katapult-button>
          <div spacer collapse></div>
          <katapult-button color="var(--paper-amber-500)" confirm on-click="externalChangesButtonClicked">Save Anyway</katapult-button>
        </div>
      </paper-dialog>
      <paper-dialog
        id="busyUploadingDialog"
        fit-into="[[$.editingContainer]]"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
      >
        <div title amber>Files Uploading</div>
        <div body style="text-align: center;">
          <div>You can not leave the files tab until your files have finished uploading</div>
        </div>
        <div buttons>
          <katapult-button color="var(--paper-amber-500)" dialog-dismiss>Okay</katapult-button>
        </div>
      </paper-dialog>
      <katapult-dialog-legacy
        id="unsavedChangesDialog"
        title="Unsaved Changes"
        fit-into="[[$.editingContainer]]"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        backdrop
      >
        <div slot="body" text-center>
          <template is="dom-if" if="[[creatingItem]]">
            <div>You have not finished creating <b>[[selectedItemTitle]]</b></div>
            <div>If you leave now this [[itemTypeTitles.lowercaseTitle]] will not be created</div>
          </template>
          <template is="dom-if" if="[[!creatingItem]]">
            <div>You have not saved your changes to <b>[[selectedItemTitle]]</b></div>
            <div>If you leave now your changes will be lost</div>
          </template>
        </div>
        <div slot="buttons" buttons-container>
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <div spacer collapse></div>
          <katapult-button color="var(--secondary-color)" confirm dialog-confirm>Discard Changes</katapult-button>
        </div>
      </katapult-dialog-legacy>
      <paper-dialog
        id="deleteItemDialog"
        fit-into="[[$.editingContainer]]"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        opened="{{deleteItemDialogOpened}}"
      >
        <div title red>Delete [[selectedItemTitle]]?</div>
        <div body style="text-align: center;">
          <div>Are you sure that you really want to delete <b>[[selectedItemTitle]]</b></div>
          <div>This action cannot be undone</div>
          <template is="dom-if" if="[[equal(category, 'reference_layers')]]">
            <div style="margin: 10px 0;">
              All reference layer items will be deleted individually and this may be a long process for large layers. Contact support for
              help with faster methods for deleting large layers.
            </div>
          </template>
        </div>
        <div buttons>
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <div spacer collapse></div>
          <katapult-button color="var(--paper-red-500)" on-click="deleteItemForcefully" loading="[[deletingItem]]" icon="delete"
            >Delete [[selectedItemTitle]]</katapult-button
          >
        </div>
      </paper-dialog>
      <div id="savedOverlay" class="overlay">
        <div id="savedOverlayContent" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <iron-icon
            style="color: var(--paper-green-500); height: 128px; width: 128px;"
            style="margin-left: 16px;"
            icon="check-circle"
          ></iron-icon>
          <div
            style="background: white; color: var(--paper-grey-600); font-size: 14pt; padding: 16px; border-radius: 48px; border: 1px solid rgba(0,0,0,0.06);"
          >
            [[savedItemTitle]] Saved Successfully
          </div>
        </div>
      </div>
      <div id="deletedOverlay" class="overlay">
        <div id="deletedOverlayContent" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <iron-icon style="color: var(--paper-red-500); height: 128px; width: 128px;" style="margin-left: 16px;" icon="delete"></iron-icon>
          <div
            style="background: white; color: var(--paper-grey-600); font-size: 14pt; padding: 16px; border-radius: 48px; border: 1px solid rgba(0,0,0,0.06);"
          >
            [[deletedItemTitle]] Deleted Successfully
          </div>
        </div>
      </div>
      <div id="workspaceHeader">
        <katapult-button
          id="workspaceBackButton"
          on-click="workspaceBackButtonClicked"
          animate
          iconOnly
          style="margin-right: 16px; border-radius: 999px;"
          icon="arrow_back"
        ></katapult-button>
        <katapult-animated-text
          id="workspaceTitle"
          animation="scroll-up"
          value="[[workspaceTitle]]"
          input="[[and(showEditor, selectedItem)]]"
          error-message="[[itemLabelErrorMessage]]"
          readonly="[[workspaceTitleReadonly]]"
          invalid="[[itemLabelErrorMessage]]"
          on-focus="notifyEditability"
          on-value-changed="itemLabelInputChanged"
        >
          <template is="dom-if" if="[[!and(showEditor, selectedItem)]]">
            <template is="dom-if" if="[[helpText.length]]">
              <iron-icon id="helpTextMoreInfo" style="margin-left:10px;" icon="help"></iron-icon>
              <paper-tooltip class="helpTooltip" position="bottom" for="helpTextMoreInfo">
                <template is="dom-repeat" items="[[helpText]]">
                  <template is="dom-if" if="[[!equal(index, 0)]]">
                    <br />
                  </template>
                  <div>[[item]]</div>
                </template>
              </paper-tooltip>
            </template>
          </template>
        </katapult-animated-text>
        <div style="flex-grow: 1;"></div>
        <div id="headerButtonsContainer">
          <div id="reorderHeaderButton">
            <katapult-button on-click="startEditOrder" icon="swap_vert">Edit [[itemTypeTitles.title]] Order</katapult-button>
          </div>
          <div id="saveCancelReorderHeaderButtons">
            <katapult-button loading="[[savingEditOrder]]" on-click="saveEditOrder" icon="save"
              >Save [[itemTypeTitles.title]] Order</katapult-button
            >
            <katapult-button on-click="cancelEditOrder" icon="clear">Cancel</katapult-button>
          </div>
          <div id="saveDeleteHeaderButtons">
            <katapult-button id="previewAssessmentButton" on-click="openAssessmentInSandbox" icon="exit_to_app">Preview</katapult-button>
            <katapult-button id="downloadExportPreviewButton" on-click="downloadPreviewExport" icon="file_download"
              >Download Preview</katapult-button
            >
            <katapult-button id="overwriteLayerButton" on-click="updateReferenceLayer" icon="input">Overwrite</katapult-button>
            <katapult-button
              id="saveItemButton"
              on-click="saveItem"
              disabled="[[!canSaveItem]]"
              loading="[[savingSelectedItem]]"
              icon="save"
              >Save</katapult-button
            >
            <katapult-button
              id="deleteItemButton"
              on-click="deleteItem"
              disabled="{{editingDisabled}}"
              icon="delete"
              color="var(--paper-red-500)"
              >Delete</katapult-button
            >
          </div>
          <div id="createHeaderButtons">
            <katapult-button
              color="var(--secondary-color)"
              on-click="saveItem"
              disabled="[[!canSaveItem]]"
              loading="[[savingSelectedItem]]"
              icon="new_releases"
              >Finish Creating [[itemTypeTitles.title]]</katapult-button
            >
          </div>
        </div>
      </div>
      <div id="workspaceContainer">
        <div id="listLayoutContainer" class="workspaceView">
          <div id="listLayoutWrapper">
            <div id="sideContainer">
              <div id="listFilterLayoutContainer" class="listContainer">
                <paper-table id="listFilter" rounded white outline dividers>
                  <paper-row pointer checkbox>
                    <paper-cell icon>
                      <paper-checkbox
                        checked="[[someFilterTagIsChecked(visibleFilterTags.*)]]"
                        on-click="toggleAllFilterTagsHandler"
                      ></paper-checkbox>
                    </paper-cell>
                    <paper-cell>
                      <span>Filter By Tag</span>
                    </paper-cell>
                  </paper-row>
                  <template is="dom-repeat" items="{{visibleFilterTags}}" as="tag">
                    <template is="dom-if" if="[[tag.name]]">
                      <paper-row pointer checkbox>
                        <paper-cell icon>
                          <paper-checkbox no-label checked="{{tag.checked}}"></paper-checkbox>
                        </paper-cell>
                        <paper-cell>
                          <model-item-tag look-like-paper-element tag="[[getProperty(allTags, tag._id)]]"></model-item-tag>
                        </paper-cell>
                      </paper-row>
                    </template>
                  </template>
                </paper-table>
              </div>
              <div id="catalogCategoryContainer" style="width: 324px;" class="listContainer">
                <div class="listHeader">
                  <paper-table style="flex-grow: 1;" rounded white outline>
                    <paper-row tall pointer input>
                      <paper-cell icon>
                        <template is="dom-if" if="[[!selectedCatalog.icon]]">
                          <iron-icon icon="communication:import-contacts"></iron-icon>
                        </template>
                        <template is="dom-if" if="[[selectedCatalog.icon]]">
                          <iron-icon icon="[[selectedCatalog.icon]]"></iron-icon>
                        </template>
                      </paper-cell>
                      <paper-cell style="padding-left: 0;">
                        <katapult-drop-down
                          class="modelList"
                          items="[[catalogOptions]]"
                          label="Select a Catalog"
                          label-path="label"
                          value-path="."
                          value="{{selectedCatalog}}"
                          no-label-float
                        ></katapult-drop-down>
                      </paper-cell>
                    </paper-row>
                  </paper-table>
                </div>
                <template is="dom-if" if="[[catalogCategories.length]]">
                  <katapult-button
                    loading="[[selectedCatalog.$adding]]"
                    on-click="promptAddCatalogToModelSpace"
                    color="var(--paper-grey-200)"
                    icon="add"
                  >
                    <template is="dom-if" if="[[catalogImportTags.length]]">Import by Tags</template>
                    <template is="dom-if" if="[[!catalogImportTags.length]]">Import Entire [[selectedCatalog.type]]</template>
                  </katapult-button>
                  <paper-table style="overflow: hidden;" rounded white outline>
                    <paper-table-scroll>
                      <template is="dom-repeat" items="[[catalogCategories]]">
                        <paper-header
                          slot="before"
                          tall
                          selected$="[[equal(catalogCategory, item.category)]]"
                          on-click="clickCatalogCategory"
                        >
                          <paper-cell icon>
                            <katapult-icon inferType icon="[[item.icon]]"></katapult-icon>
                          </paper-cell>
                          <paper-cell>
                            <span>[[item.title]]</span>
                          </paper-cell>
                          <paper-cell icon-button>
                            <template is="dom-if" if="[[item.mayImportCategory]]">
                              <katapult-button
                                icon="add"
                                iconOnly
                                style="border-radius: 999px;"
                                color="white"
                                on-click="promptAddCatalogCategoryToModelSpace"
                              ></katapult-button>
                            </template>
                          </paper-cell>
                        </paper-header>
                      </template>
                    </paper-table-scroll>
                  </paper-table>
                </template>
              </div>
            </div>

            <div id="listContainer" class="listContainer">
              <div id="listSearchContainer" class="listHeader">
                <paper-table rounded white outline>
                  <paper-row input>
                    <paper-cell icon><iron-icon icon="search"></iron-icon></paper-cell>
                    <paper-cell style="padding-left: 0;">
                      <paper-input
                        id="listSearchInput"
                        style="width: 220px;"
                        label="Search [[listItemTitles.title]]"
                        no-label-float
                        value="{{listSearchText}}"
                        on-focus="selectInputText"
                      ></paper-input>
                    </paper-cell>
                  </paper-row>
                </paper-table>
                <katapult-button
                  id="createItemButton"
                  iconOnly
                  style="border-radius: 999px;"
                  color="var(--secondary-color)"
                  icon="add"
                  on-click="createItem"
                  loading="[[uploadingFiles]]"
                ></katapult-button>
                <paper-table id="catalogTagSelector" style="margin-left: -56px; width: 269px;" rounded white outline overflow-hidden>
                  <paper-row input>
                    <paper-cell icon><katapult-icon icon="filter_list"></katapult-icon></paper-cell>
                    <paper-cell style="padding-left: 0; padding-right: 0;">
                      <model-item-tag-selector
                        style="width: -webkit-fill-available;"
                        model-path="[[selectedCatalog.path]]"
                        on-change="catalogTagSelectorChanged"
                        maySelectDefaultTags
                        maxOptionsVisible="1"
                        look-like-paper-element
                      ></model-item-tag-selector>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
              <paper-table style="overflow: hidden; width: 560px;" rounded white outline>
                <template is="dom-if" if="[[!showCatalog]]" restamp>
                  <paper-row style="padding-right: 16px;" tall$="[[showCatalog]]" raised-on-scroll grey>
                    <template is="dom-if" if="[[showCatalog]]">
                      <paper-cell icon></paper-cell>
                    </template>
                    <template is="dom-if" if="[[editingOrder]]">
                      <paper-cell icon></paper-cell>
                    </template>
                    <template is="dom-if" if="[[!showCatalog]]">
                      <template is="dom-if" if="[[showEditabilityColumn]]">
                        <paper-cell icon></paper-cell>
                      </template>
                    </template>
                    <template is="dom-if" if="[[showListIcons]]">
                      <paper-cell icon></paper-cell>
                    </template>
                    <paper-cell>[[listItemTitles.titleSingular]]</paper-cell>
                    <template is="dom-if" if="[[equal(category, 'files')]]" restamp>
                      <paper-cell style="flex-grow: 0.25;">Size</paper-cell>
                      <paper-cell style="flex-grow: 0.5;">Date Uploaded</paper-cell>
                    </template>
                    <template is="dom-if" if="[[showTagsHeader(showCatalog, category)]]">
                      <paper-cell>Tags</paper-cell>
                    </template>
                    <template is="dom-if" if="[[and(showCatalog, catalogCategoryDetails.mayImportIndividually)]]">
                      <paper-cell center style="max-width: 80px; text-align: center; font-size: 9pt;">Add to Model</paper-cell>
                    </template>
                  </paper-row>
                </template>
                <paper-table-scroll style="overflow-y: scroll;" on-sort-changed="categoryDataSortChanged">
                  <template is="dom-if" if="[[listLoading]]">
                    <paper-row slot="before" style="height: 96px;">
                      <paper-cell center>
                        <paper-spinner-lite active></paper-spinner-lite>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <template is="dom-if" if="[[!listLoading]]">
                    <template is="dom-if" if="[[!filteredListItems.length]]">
                      <paper-row tall$="[[showCatalog]]" slot="before">
                        <paper-cell center>
                          <iron-icon icon="katapult-misc:search-off"></iron-icon>
                          <span>No Results</span>
                        </paper-cell>
                      </paper-row>
                    </template>
                    <template is="dom-if" if="[[filteredListItems.length]]">
                      <template is="dom-repeat" items="[[filteredListItems]]">
                        <paper-row
                          class="listItem"
                          expand
                          white
                          selected$="[[equal(item.$key, selectedItem)]]"
                          slot="[[getListItemSlot(editingOrder)]]"
                          pointer
                          divider
                          on-click="listItemClickHandler"
                          on-contextmenu="listItemClickHandler"
                        >
                          <template is="dom-if" if="[[editingOrder]]">
                            <paper-cell drag-handle icon>
                              <iron-icon icon="katapult-misc:drag-indicator"></iron-icon>
                            </paper-cell>
                          </template>
                          <template is="dom-if" if="[[showCatalog]]">
                            <paper-cell style="padding: 14px;" icon>
                              <template is="dom-if" if="[[item.$upToDate]]">
                                <iron-icon style="color: var(--paper-green-500);" icon="check-circle"></iron-icon>
                              </template>
                              <template is="dom-if" if="[[item.$outOfDate]]">
                                <iron-icon style="color: var(--paper-red-500);" icon="av:fiber-new"></iron-icon>
                              </template>
                            </paper-cell>
                          </template>
                          <template is="dom-if" if="[[!showCatalog]]">
                            <template is="dom-if" if="[[showEditabilityColumn]]">
                              <paper-cell icon>
                                <template is="dom-if" if="[[equal(item.editability, 'only_picklist_items')]]">
                                  <iron-icon icon="av:playlist-add" style="color: var(--paper-red-500);"></iron-icon>
                                </template>
                                <template is="dom-if" if="[[equal(item.editability, 'uneditable')]]">
                                  <iron-icon icon="lock" style="color: var(--paper-red-500);"></iron-icon>
                                </template>
                              </paper-cell>
                            </template>
                          </template>
                          <template is="dom-if" if="[[showListIcons]]" restamp>
                            <paper-cell icon>
                              <template is="dom-if" if="[[item.$showProgress]]" restamp>
                                <s-circle-progress value="[[item.$progress]]" max="100" stroke-width="3"></s-circle-progress>
                              </template>
                              <template is="dom-if" if="[[!item.$showProgress]]" restamp>
                                <template is="dom-if" if="[[item.$icon_tooltip]]">
                                  <sl-tooltip hoist placement="bottom" content="[[item.$icon_tooltip]]">
                                    <iron-icon icon="[[item.$icon]]" style$="color: [[item.$iconColor]];"></iron-icon>
                                  </sl-tooltip>
                                </template>
                                <template is="dom-if" if="[[!item.$icon_tooltip]]">
                                  <iron-icon icon="[[item.$icon]]" style$="color: [[item.$iconColor]];"></iron-icon>
                                </template>
                              </template>
                            </paper-cell>
                          </template>
                          <paper-cell
                            style="flex-direction: column; align-items: flex-start; justify-content: center; min-width: min-content;"
                          >
                            <highlight-text filter="[[sanitizedListSearchText]]" title="[[item.$label]]">
                              <!--style="margin-left:15px;"-->
                              <span style="overflow: hidden; text-overflow: ellipsis">[[item.$label]]</span>
                            </highlight-text>
                            <template is="dom-if" if="[[and(showCatalog, item.description)]]">
                              <div style="font-size: 9pt;">[[item.description]]</div>
                            </template>
                          </paper-cell>
                          <template is="dom-if" if="[[equal(category, 'files')]]">
                            <paper-cell style="flex-grow: 0.25;">[[item.$size]]</paper-cell>
                            <paper-cell style="flex-grow: 0.5;">[[item.$upload_date]]</paper-cell>
                          </template>
                          <template is="dom-if" if="[[item.overhead_category]]">
                            <paper-cell fit-content>
                              <sl-tooltip hoist placement="bottom" content="This is an overhead category">
                                <katapult-icon icon="paid" color="var(--paper-red-500)"></katapult-icon>
                              </sl-tooltip>
                            </paper-cell>
                          </template>
                          <template is="dom-if" if="[[equal(category, 'time_categories')]]">
                            <div style="flex-grow: 0.1; align-items: center; display: flex; flex-direction: row;">
                              <template is="dom-if" if="[[hasOverheadUsers(item.users, extraCategoryData.users)]]">
                                <paper-cell fit-content>
                                  <sl-tooltip hoist placement="bottom" content="This category has overhead users">
                                    <katapult-icon icon="account_circle" color="var(--paper-red-500)"></katapult-icon>
                                  </sl-tooltip>
                                </paper-cell>
                              </template>
                              <template is="dom-repeat" items="[[item.labels]]" as="label" index-as="labelIndex" filter="coloredLabels">
                                <paper-cell fit-content>
                                  <sl-tooltip hoist placement="bottom">
                                    <div
                                      class="colorBox"
                                      style$="background:[[getProperty(extraCategoryData.labels, label, 'color')]]"
                                    ></div>
                                    <div slot="content">[[getProperty(extraCategoryData.labels, label, 'name')]]</div>
                                  </sl-tooltip>
                                </paper-cell>
                              </template>
                            </div>
                          </template>
                          <div class="tags">
                            <template is="dom-repeat" items="[[getCuratedItemTags(item, visibleFilterTags.*)]]" as="tagId">
                              <template is="dom-if" if="[[getProperty(allTags, tagId, 'name')]]">
                                <model-item-tag tag="[[getProperty(allTags, tagId)]]"></model-item-tag>
                              </template>
                            </template>
                          </div>
                          <template is="dom-if" if="[[and(showCatalog, catalogCategoryDetails.mayImportIndividually)]]">
                            <paper-cell right style="flex-grow: unset; flex-basis: auto; padding: 0; gap: 0.5em;">
                              <template is="dom-if" if="[[equal(item.$key, lastCatalogCategoryItemDetails.item)]]">
                                <katapult-button
                                  iconOnly
                                  noBorder
                                  noBackground
                                  icon="undo"
                                  loading="[[revertingLastCatalogCategoryItem]]"
                                  on-click="revertLastCatalogCategoryItem"
                                ></katapult-button>
                              </template>
                              <template is="dom-if" if="[[!item.$upToDate]]">
                                <katapult-button
                                  iconOnly
                                  noBorder
                                  noBackground
                                  icon="add_circle"
                                  loading="[[item.$adding]]"
                                  on-click="addCatalogCategoryItemToModelSpace"
                                ></katapult-button>
                              </template>
                            </paper-cell>
                          </template>
                        </paper-row>
                      </template>
                    </template>
                  </template>
                </paper-table-scroll>
              </paper-table>
            </div>

            <div id="rightSideContainer" class="listContainer">
              <div class="catalog-description-container" style="width: 324px; margin-top: 72px;">
                <div style="font-weight: bold;">About [[selectedCatalog.label]]</div>
                <div>[[selectedCatalog.description]]</div>
              </div>
            </div>
          </div>
        </div>
        <div id="editingContainer" class="workspaceView" overflow-hidden animate>
          <template is="dom-if" if="[[equal(category, 'attributes')]]" restamp on-dom-change="editorDomChange">
            <katapult-attribute-editor
              id="editor"
              category-data="[[categoryData]]"
              editing-disabled="{{editingDisabled}}"
              catalogs-data="[[catalogsData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-attribute-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'compatible_unit_automations')]]" restamp on-dom-change="editorDomChange">
            <katapult-compatible-unit-automations-editor
              id="editor"
              category-data="[[categoryData]]"
              editing-disabled="{{editingDisabled}}"
              catalogs-data="[[catalogsData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-compatible-unit-automations-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'attribute_sets')]]" restamp on-dom-change="editorDomChange">
            <katapult-attribute-sets-editor
              id="editor"
              category-data="[[categoryData]]"
              editing-disabled="{{editingDisabled}}"
              catalogs-data="[[catalogsData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-attribute-sets-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'tools')]]" restamp on-dom-change="editorDomChange">
            <katapult-tool-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-tool-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'toolsets')]]" restamp on-dom-change="editorDomChange">
            <katapult-toolset-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-toolset-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'photo_routines')]]" restamp on-dom-change="editorDomChange">
            <katapult-routine-editor
              id="editor"
              input-models="[[inputModels]]"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              editing-disabled="{{editingDisabled}}"
            >
            </katapult-routine-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'photo_elements')]]" restamp on-dom-change="editorDomChange">
            <katapult-photo-element-editor
              id="editor"
              input-models="[[inputModels]]"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              editing-disabled="{{editingDisabled}}"
            >
            </katapult-photo-element-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'photo_toolsets')]]" restamp on-dom-change="editorDomChange">
            <katapult-photo-toolset-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-photo-toolset-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'construction_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-routine-editor
              id="editor"
              construction-spec-mode
              input-models="[[inputModels]]"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-routine-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'clearance_rules')]]" restamp on-dom-change="editorDomChange">
            <katapult-clearance-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-clearance-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'proposed_cable_logic')]]" restamp on-dom-change="editorDomChange">
            <katapult-proposed-logic-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-proposed-logic-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'compatible_units')]]" restamp on-dom-change="editorDomChange">
            <katapult-compatible-unit-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-compatible-unit-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'photo_forms')]]" restamp on-dom-change="editorDomChange">
            <katapult-photo-form-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              company-modules="[[companyModules]]"
            >
            </katapult-photo-form-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'mobile_assessments')]]" restamp on-dom-change="editorDomChange">
            <katapult-assessment-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-assessment-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'map_print_templates')]]" restamp on-dom-change="editorDomChange">
            <katapult-map-print-template-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-map-print-template-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'saved_view_templates')]]" restamp on-dom-change="editorDomChange">
            <katapult-saved-view-template-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-saved-view-template-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'configurable_exports')]]" restamp on-dom-change="editorDomChange">
            <katapult-configurable-export-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-configurable-export-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'web_automations')]]" restamp on-dom-change="editorDomChange">
            <katapult-web-automations-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-web-automations-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'files')]]" restamp on-dom-change="editorDomChange">
            <katapult-files-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-files-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'time_categories')]]" restamp on-dom-change="editorDomChange">
            <katapult-project-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-project-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'custom_icons')]]" restamp>
            <katapult-custom-icons-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-custom-icons-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'custom_line_styles')]]" restamp>
            <katapult-custom-line-styles-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-custom-line-styles-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'quality_control')]]" restamp>
            <katapult-quality-control-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
            >
            </katapult-quality-control-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'reference_layers')]]" restamp>
            <katapult-reference-layer-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              firestore="[[categoryDetails.firestore]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              hide-save-button="{{hideSaveButton}}"
              render-editor="[[renderEditor]]"
              help-text="{{helpText}}"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-reference-layer-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'api_layers')]]" restamp>
            <katapult-api-layer-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              hide-save-button="{{hideSaveButton}}"
              render-editor="[[renderEditor]]"
              help-text="{{helpText}}"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              on-clear-selected-item-forcefully="clearSelectedItemForcefully"
            >
            </katapult-api-layer-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'portal_app_types')]]" restamp on-dom-change="editorDomChange">
            <katapult-portal-app-type-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-portal-app-type-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'portal_display_options')]]" restamp on-dom-change="editorDomChange">
            <katapult-portal-display-options-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-portal-display-options-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'portal_user_options')]]" restamp on-dom-change="editorDomChange">
            <katapult-portal-user-options-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-portal-user-options-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'model_options')]]" restamp on-dom-change="editorDomChange">
            <katapult-model-options-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
              enabled-features="[[enabledFeatures]]"
            >
            </katapult-model-options-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'hub_application_configurations')]]" restamp on-dom-change="editorDomChange">
            <katapult-hub-application-configuration-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-hub-application-configuration-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'default_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-default-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            ></katapult-default-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'pole_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-pole-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-pole-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'wire_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-wire-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-wire-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'anchor_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-anchor-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-anchor-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'insulator_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-insulator-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-insulator-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'arm_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-arm-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-arm-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'equipment_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-equipment-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-equipment-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'sidewalk_brace_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-sidewalk-brace-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-sidewalk-brace-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'pushbrace_specs')]]" restamp on-dom-change="editorDomChange">
            <katapult-pushbrace-spec-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-pushbrace-spec-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'load_cases')]]" restamp on-dom-change="editorDomChange">
            <katapult-load-case-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-load-case-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'cross_server_model_space_sharing')]]" restamp on-dom-change="editorDomChange">
            <katapult-cross-server-model-space-sharing
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              user-company-name="[[userCompanyName]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-cross-server-model-space-sharing>
          </template>
          <template is="dom-if" if="[[equal(category, 'virtual_rideout')]]" restamp on-dom-change="editorDomChange">
            <katapult-virtual-rideout-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              user-company-name="[[userCompanyName]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-virtual-rideout-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'make_ready_notification')]]" restamp on-dom-change="editorDomChange">
            <katapult-make-ready-notification-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              user-company-name="[[userCompanyName]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-make-ready-notification-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'dds_bundles')]]" restamp on-dom-change="editorDomChange">
            <katapult-dds-bundle-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              user-company-name="[[userCompanyName]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-dds-bundle-editor>
          </template>
          <template is="dom-if" if="[[equal(category, 'mobile_options')]]" restamp on-dom-change="editorDomChange">
            <katapult-mobile-options-editor
              id="editor"
              category-data="[[categoryData]]"
              can-save-item="{{canSaveItem}}"
              editing-container="[[$.editingContainer]]"
              item-type-titles="[[itemTypeTitles]]"
              model-space-details="[[modelSpaceDetails]]"
              category-details="[[categoryDetails]]"
              data-path="[[categoryDataPath]]"
              unsaved-changes="{{unsavedChanges}}"
              external-changes="{{externalChanges}}"
              label="{{itemLabel}}"
              label-error-message="{{itemLabelErrorMessage}}"
              render-editor="[[renderEditor]]"
              saving-item="[[savingSelectedItem]]"
              user-group="[[userGroup]]"
              user-company-name="[[userCompanyName]]"
              on-item-set="editorItemSet"
              on-save-item="saveItem"
              uploading="{{uploadingFiles}}"
            >
            </katapult-mobile-options-editor>
          </template>
        </div>

        <template is="dom-if" if="[[!hasParentWorkspace]]" on-dom-change="setupPlaImporter">
          <!-- IMPORT PLA -->
          <katapult-model-space-pla-import-wizard
            id="plaImportWizard"
            class="workspaceView"
            model-space-config="{{modelSpaceConfig}}"
            kpla-checkbox="[[companyModules.integrated_pole_loading]]"
            clear-existing-checkbox
            company-modules="[[companyModules]]"
            on-go-back="goToPreviousStep"
            on-finished="finishImportPla"
            user-group="[[userGroup]]"
          >
          </katapult-model-space-pla-import-wizard>
        </template>

        <wizard-page id="newItemNameContainer" class="workspaceView" column>
          <div class="prompt">Choose a name for your new [[itemTypeTitles.lowercaseTitle]]</div>
          <div id="newItemNameInputContainer">
            <katapult-button iconOnly noBorder icon="arrow_back" on-click="exitCreateItem"></katapult-button>
            <paper-table style="margin-left: 16px;" rounded white outline>
              <paper-row pointer input>
                <paper-cell>
                  <paper-input
                    id="newItemNameInput"
                    style="width: 220px;"
                    label="My New [[itemTypeTitles.title]]"
                    no-label-float
                    value="{{newItemNameInput}}"
                    on-keypress="newItemNameInputKeypress"
                  ></paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
          </div>
          <div style="width: 100%; height: 100px;" class="inPlaceItems">
            <div>
              <div id="newItemNameErrorMessage" style="color: var(--paper-red-500);">[[newItemNameErrorMessage]]</div>
            </div>
            <div>
              <katapult-button
                class="wizardButton"
                id="newItemNameContinueButton"
                style$="[[elemStyle()]]"
                color="var(--secondary-color)"
                on-click="editNewItem"
                >Continue</katapult-button
              >
            </div>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center;"></div>
        </wizard-page>
      </div>
    `;
  }

  static get properties() {
    return {
      catalogCategory: {
        type: String,
        readOnly: true
      },
      catalogCategoryDetails: {
        type: Object,
        readOnly: true
      },
      catalogOptions: {
        type: Object,
        readOnly: true
      },
      category: {
        type: String,
        notify: true,
        readOnly: true
      },
      categoryDetails: {
        type: Object,
        readOnly: true
      },
      categories: {
        type: Array,
        value: [
          {
            title: 'Attributes',
            category: 'attributes',
            path: 'models/attributes',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Attribute Sets',
            category: 'attribute_sets',
            path: 'models/attribute_sets',
            icon: 'line-style',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Tools',
            category: 'tools',
            path: 'models/mapping_buttons',
            icon: 'build',
            mayImportIndividually: true,
            filter: (item) => item.view != 'assessment',
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Toolsets',
            category: 'toolsets',
            path: 'models/button_groups',
            icon: 'katapult-misc:construction',
            sortPath: '_priority',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Photo Elements',
            category: 'photo_elements',
            path: 'models/input_models',
            icon: 'category',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Photo Routines',
            category: 'photo_routines',
            path: 'models/routines',
            icon: 'image:add-to-photos',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Photo Toolsets',
            category: 'photo_toolsets',
            path: 'models/input_model_groups',
            icon: 'image:photo-library',
            sortPath: '_priority',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Construction Specs',
            category: 'construction_specs',
            path: 'models/construction_specs',
            icon: 'gavel',
            sortPath: 'order',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Clearance Rules',
            category: 'clearance_rules',
            path: 'models/make_ready/make_ready_items',
            icon: 'editor:format-line-spacing',
            sortPath: 'order',
            mayImportCategory: true,
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'Proposed Cable Logic',
            category: 'proposed_cable_logic',
            path: 'models/make_ready/proposed_cable_logic',
            icon: 'star',
            createItems: false,
            showList: false,
            showEditor: true
          },
          {
            title: 'Photo Forms',
            category: 'photo_forms',
            path: 'models/export_models/photo_form_templates',
            icon: 'image:photo-album',
            mayImportIndividually: true,
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'Map Print Templates',
            category: 'map_print_templates',
            path: 'models/export_models/map_print_templates',
            icon: 'print',
            mayImportIndividually: true,
            createItems: false,
            showEditor: false,
            showList: true
          },
          {
            title: 'Saved View Templates',
            category: 'saved_view_templates',
            path: 'models/saved_views',
            icon: 'katapult-misc:preview',
            mayImportIndividually: true,
            createItems: false,
            showEditor: false,
            showList: true
          },
          {
            title: 'Configurable Exports',
            category: 'configurable_exports',
            path: 'models/export_models/configurable_exports',
            icon: 'katapult-misc:preview',
            mayImportIndividually: true,
            createItems: true,
            mayEditLabel: true,
            showEditor: true,
            showList: true
          },
          {
            title: 'Web Automations',
            category: 'web_automations',
            path: 'models/export_models/web_automations',
            icon: 'picture-in-picture',
            mayImportIndividually: true,
            createItems: true,
            mayEditLabel: true,
            showEditor: true,
            showList: true
          },
          {
            title: 'Mobile Assessments',
            category: 'mobile_assessments',
            path: 'models/mapping_buttons',
            icon: 'hardware:smartphone',
            mayImportIndividually: true,
            filter: (item) => item.view == 'assessment',
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Files',
            category: 'files',
            path: 'models/files',
            icon: 'editor:insert-drive-file',
            createItems: true,
            showList: true,
            showEditor: false,
            sortPath: 'upload_date',
            sortReverse: true
          },
          {
            title: 'Custom Icons',
            category: 'custom_icons',
            path: 'models/custom_icons',
            icon: 'icons:change-history',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Custom Line Styles',
            category: 'custom_line_styles',
            path: 'models/custom_line_styles',
            icon: 'icons:line-style',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Quality Control',
            category: 'quality_control',
            path: 'models/quality_control',
            icon: 'icons:assignment',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Time Categories',
            category: 'time_categories',
            icon: 'assignment',
            path: 'project_tracking/projects',
            sortPath: 'archived',
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'Application Types',
            category: 'portal_app_types',
            icon: 'assignment',
            path: 'portal_config/app_types',
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'Display Options',
            category: 'portal_display_options',
            icon: 'display_settings',
            path: 'portal_config/display_options',
            createItems: false,
            showEditor: true,
            showList: false
          },
          {
            title: 'User Options',
            category: 'portal_user_options',
            icon: 'manage_accounts',
            path: 'portal_config/user_options',
            createItems: false,
            showEditor: true,
            showList: false
          },
          {
            title: 'Reference Layers',
            category: 'reference_layers',
            icon: 'maps:place',
            path: 'reference_layers',
            firestore: true,
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'API Layers',
            category: 'api_layers',
            icon: 'maps:layers',
            path: 'map_api_layers',
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'Model Options',
            category: 'model_options',
            icon: 'settings',
            path: 'models/config',
            firestore: false,
            createItems: false,
            showList: false,
            showEditor: true
          },
          {
            title: 'Application Configurations',
            category: 'hub_application_configurations',
            icon: 'assignment',
            path: 'models/application_companies',
            createItems: true,
            showList: true,
            showEditor: true
          },
          {
            title: 'Default Settings',
            category: 'default_specs',
            path: 'models/pole_loading/defaults',
            icon: 'list',
            createItems: false,
            showEditor: true,
            showList: false
          },
          {
            title: 'Pole Specs',
            category: 'pole_specs',
            path: 'models/pole_loading/specs/pole_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Wire Specs',
            category: 'wire_specs',
            path: 'models/pole_loading/specs/wire_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Anchor Specs',
            category: 'anchor_specs',
            path: 'models/pole_loading/specs/anchor_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Insulator Specs',
            category: 'insulator_specs',
            path: 'models/pole_loading/specs/insulator_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Arm Specs',
            category: 'arm_specs',
            path: 'models/pole_loading/specs/arm_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Sidewalk Brace Specs',
            category: 'sidewalk_brace_specs',
            path: 'models/pole_loading/specs/sidewalk_brace_specs',
            icon: 'horizontal_rule',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Pushbrace Specs',
            category: 'pushbrace_specs',
            path: 'models/pole_loading/specs/pushbrace_specs',
            icon: 'pen_size_1',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Equipment Specs',
            category: 'equipment_specs',
            path: 'models/pole_loading/specs/equipment_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Load Cases',
            category: 'load_cases',
            path: 'models/pole_loading/load_cases',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Model Sharing',
            category: 'cross_server_model_space_sharing',
            icon: 'cloud_sync',
            firestore: false,
            createItems: false,
            showList: false,
            showEditor: true
          },
          {
            title: 'Compatible Units',
            category: 'compatible_units',
            path: 'models/compatible_unit_models/cus',
            icon: 'av:art-track',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Virtual Rideout',
            category: 'virtual_rideout',
            icon: 'directions_car',
            path: 'models/make_ready/virtual_rideout/settings',
            firestore: false,
            createItems: false,
            showList: false,
            showEditor: true
          },
          {
            title: 'Make Ready Notification',
            category: 'make_ready_notification',
            path: 'models/export_models/spreadsheets/make_ready_notification',
            icon: 'notifications',
            firestore: false,
            createItems: false,
            showList: false,
            showEditor: true
          },
          {
            title: 'DDS Bundles',
            category: 'dds_bundles',
            path: 'models/export_models/dds/bundle_specs',
            icon: 'list',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Compatible Unit Automations',
            category: 'compatible_unit_automations',
            icon: 'photo_filter',
            path: 'models/compatible_unit_models/automations',
            mayImportIndividually: true,
            showEditor: true,
            createItems: true,
            showList: true
          },
          {
            title: 'Mobile Options',
            category: 'mobile_options',
            icon: 'settings',
            path: 'models/config/mobile',
            createItems: false,
            showEditor: true,
            showList: false
          }
        ]
      },
      creatingItem: {
        type: Boolean,
        value: false,
        readOnly: true
      },
      editingOrder: {
        type: Boolean,
        value: false,
        readOnly: true
      },
      editingOrderInitialized: {
        type: Boolean,
        value: false,
        readOnly: true
      },
      visibleFilterTags: {
        type: Array,
        value: () => []
      },
      showImportPla: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true
      },
      title: {
        type: String
      },
      newItemKey: {
        type: String,
        value: null
      },
      modelSpaceOptions: {
        type: Object,
        notify: true,
        readOnly: true
      },
      modelSpaceChooserOptions: {
        type: Object,
        notify: true,
        readOnly: true
      },
      modelSpace: {
        type: String,
        notify: true,
        readOnly: true
      },
      modelSpaceDetails: {
        type: Object,
        notify: true,
        readOnly: true,
        value: null
      },
      renderEditor: {
        type: Boolean,
        value: false,
        readOnly: true
      },
      selectedCatalog: {
        type: Object,
        value: null
      },
      selectedItem: {
        type: String,
        notify: true,
        readOnly: true
      },
      selectedItemData: {
        type: Object,
        value: null,
        notify: true,
        readOnly: true
      },
      showCatalog: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true
      },
      showEditor: {
        type: String,
        value: false,
        readOnly: true
      },
      showSubWorkspace: {
        type: Boolean,
        value: false,
        readOnly: true
      },
      editingDisabled: {
        type: Boolean,
        value: false
      },
      uploadingFiles: {
        type: Boolean,
        value: false
      },
      hasParentWorkspace: {
        type: Boolean,
        value: false
      },
      companyModules: {
        type: Object,
        value: {}
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      }
    };
  }

  static get observers() {
    return [
      'updateEditorEditingItem(selectedItemData, categoryData, categoryDetails, editorRenderFlag, signedIn)',
      'newItemNameInputChanged(newItemNameInput)',
      'updateNewItemKeyExists(newItemKey, categoryData.*)',
      'updateSelectedItemData(selectedItem, creatingItem, categoryData.*)',
      'updateCategoryDataArray(categoryData.*, categoryDetails)',
      'updateTitle(categoryDetails, selectedItem, itemLabel, creatingItem, showEditor, showCatalog, showImportPla)',
      'updateCategoryDataPath(categoryDetails, modelSpaceDetails)',
      'updateView(category, selectedItem, creatingItem, showCatalog)',
      'itemContextMenuChanges(itemContextMenuOpened, renameItemDialogOpened, deleteItemDialogOpened)',
      'updateListItems(categoryDataArray.*, catalogCategoryDataArray.*, showCatalog)',
      'updateFilteredListItems(listItems.*, listSearchText, editingOrder, showCatalog, catalogCategory, category, visibleFilterTags.*)',
      'updateCatalogCategories(selectedCatalog, filteredCatalogData.*)',
      'updateCatalogCategoryDataArray(catalogCategory, catalogCategoryDetails, filteredCatalogData.*, catalogCategoryModelSpaceData.*)',
      'activeCategoryChanged(category, showCatalog, catalogCategory)',
      'updateCategoryDetails(category, catalogCategory)',
      'updateListLoading(categoryDataLoading, showCatalog, catalogDataLoading, catalogCategoryModelSpaceDataLoading, forceShowListLoading)',
      'updateCatalogDataPath(selectedCatalog)',
      'updateCatalogCategoryModelSpaceDataPath(catalogCategory, catalogCategoryDetails, modelSpaceDetails)',
      'updateModelSpaceOptions(catalogsData.*, modelOptions.*, modelSpace, userGroup, userCompanyName, companyModules)',
      'updateModelSpaceDetails(modelSpace, modelSpaceOptions.*)',
      'updateShowEditabilityColumn(showEditabilityIcons, filteredListItems.*)',
      'ensureModelSpaceExists(modelSpaceChooserOptions, catalogDataLoading, modelOptionsLoading)',
      'updateRenderEditor(showEditor)',
      'updateSelectedItemDataFirebaseUrl(config.appName, categoryDataPath, selectedItem)',
      'updateExtraCategoryData(category, userGroup)',
      'updateWorkspaceTitleReadonly(editingDisabled, selectedItem)',
      'setVisibleFilterTags(showCatalog, catalogData.*, modelTags, category, listItems.*)',
      'toggleAllTagsOnForEditors(allTags, visibleFilterTags, category, showCatalog, catalogCategory)',
      'updateFilteredCatalogData(catalogData.*, categories, catalogImportTags)'
    ];
  }

  constructor() {
    super();

    this.or = (...vals) => vals.some((x) => x);
    this.and = (...vals) => vals.every((x) => x);
    this.equal = (a, b) => a == b;

    this.camelCase = (x) => CamelCase(x);
    this.selectInputText = (e) => e.currentTarget.$?.['nativeInput']?.select();
    this.showTagsHeader = (showCatalog, category) => !showCatalog && this.categoryHasItemTags(category);

    /** @type {?string} */
    this.category = null;
    this.modelTags = null;
    this.catalogImportTags = [];
  }

  connectedCallback() {
    super.connectedCallback();

    this.mousedownHandler = (e) => {
      let composedPath = e.composedPath();
      if (
        !composedPath.includes(this.$.itemContextMenu) &&
        !composedPath.some((elem) => elem.classList != null && elem.classList.contains('listItem'))
      ) {
        this.closeItemContextMenu();
      }
    };

    this.keydownHandler = (e) => {
      if (e.key == 'Escape') {
        this.closeItemContextMenu();
      }
    };

    this.createNewAttributeHandler = () => {
      this.openSubWorkspace({ category: 'attributes', create: true });
    };

    this.createNewPicklistItemHandler = (e) => {
      this.openSubWorkspace({ category: 'attributes', selectedItem: e.detail.attribute_name, focusStep: 'picklist' });
    };

    this.createNewClearanceRuleHandler = (e) => {
      this.openSubWorkspace({ category: 'clearance_rules', create: true });
    };

    this.createNewToolsetHandler = (e) => {
      this.openSubWorkspace({ category: 'toolsets', create: true });
    };

    this.createNewToolHandler = (e) => {
      this.openSubWorkspace({ category: 'tools', create: true });
    };

    this.createNewPhotoToolHandler = (e) => {
      this.openSubWorkspace({ category: 'photo_routines', create: true });
    };

    ['mousedown'].forEach((eventType) => {
      document.addEventListener(eventType, this.mousedownHandler);
    });

    document.addEventListener('keydown', this.keydownHandler);
    document.addEventListener('create-new-attribute', this.createNewAttributeHandler);
    document.addEventListener('create-new-picklist-item', this.createNewPicklistItemHandler);
    document.addEventListener('create-new-clearance-rule', this.createNewClearanceRuleHandler);
    document.addEventListener('create-new-toolset', this.createNewToolsetHandler);
    document.addEventListener('create-new-tool', this.createNewToolHandler);
    document.addEventListener('create-new-photo-tool', this.createNewPhotoToolHandler);

    this.integratedPoleLoadingImporterFlagListener = addFlagListener('integrated_pole_loading_importer', (enabled) => {
      this.set('enabledFeatures.integrated_pole_loading_importer', enabled);
    });
    this.configurableKMZIconFallbackFlagListener = addFlagListener('configurable_kmz_icon_fallback', (enabled) => {
      this.set('enabledFeatures.configurable_kmz_icon_fallback', enabled);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    ['mousedown'].forEach((eventType) => {
      document.removeEventListener(eventType, this.mousedownHandler);
    });

    document.removeEventListener('keydown', this.keydownHandler);
    document.removeEventListener('create-new-attribute', this.createNewAttributeHandler);
    document.removeEventListener('create-new-picklist-item', this.createNewPicklistItemHandler);
    document.removeEventListener('create-new-clearance-rule', this.createNewClearanceRuleHandler);
    document.removeEventListener('create-new-toolset', this.createNewToolsetHandler);
    document.removeEventListener('create-new-tool', this.createNewToolHandler);
    document.removeEventListener('create-new-photo-tool', this.createNewPhotoToolHandler);

    removeFlagListener('integrated_pole_loading_importer', this.integratedPoleLoadingImporterFlagListener);
    removeFlagListener('configurable_kmz_icon_fallback', this.configurableKMZIconFallbackFlagListener);
  }

  ready() {
    super.ready();

    this.$this = this;

    this.setAttribute('katapult-drop-down-fit-into', true);

    const anim = new AnimationManager(this);
    this._animationManager = anim;

    anim.register(this.$.catalogTagSelector, {
      observer: 'showCatalog, selectedCatalog',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(12px)' }
        },
        {
          if: (showCatalog, selectedCatalog) => showCatalog && selectedCatalog,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.createItemButton, {
      observer: 'showCatalog, categoryDetails.createItems',
      rules: [
        {
          if: true,
          style: { $invisible: false, transform: 'none' }
        },
        {
          if: (showCatalog, create) => showCatalog || !create,
          style: { $invisible: true, transform: 'translateX(12px)' }
        }
      ]
    });

    /* Saved Deleted Overlays */
    anim.register(this.$.savedOverlay, {
      observer: 'showSavedOverlay',
      rules: [
        {
          if: true,
          style: { $invisible: true }
        },
        {
          if: (showSavedOverlay) => showSavedOverlay,
          style: { $invisible: false }
        }
      ]
    });

    anim.register(this.$.savedOverlayContent, {
      observer: 'showSavedOverlay',
      rules: [
        {
          if: true,
          style: { transform: 'translateY(24px)' }
        },
        {
          if: (showSavedOverlay) => showSavedOverlay,
          style: { transform: 'none' }
        }
      ]
    });

    anim.register(this.$.deletedOverlay, {
      observer: 'showDeletedOverlay',
      rules: [
        {
          if: true,
          style: { $invisible: true }
        },
        {
          if: (showDeletedOverlay) => showDeletedOverlay,
          style: { $invisible: false }
        }
      ]
    });

    anim.register(this.$.deletedOverlayContent, {
      observer: 'showDeletedOverlay',
      rules: [
        {
          if: true,
          style: { transform: 'translateY(24px)' }
        },
        {
          if: (showDeletedOverlay) => showDeletedOverlay,
          style: { transform: 'none' }
        }
      ]
    });

    /* Name New Item */
    anim.register(this.$.newItemNameContinueButton, {
      observer: 'newItemNameValid, newItemKeyExists',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (newItemNameValid, newItemKeyExists) => newItemNameValid && !newItemKeyExists,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.newItemNameErrorMessage, {
      observer: 'newItemNameErrorMessage',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (newItemNameErrorMessage) => newItemNameErrorMessage,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    /* Main Header Back Button */
    anim.register(this.$.workspaceBackButton, {
      observer: 'showCatalog, showEditor, selectedItem, showImportPla',
      rules: [
        {
          if: true,
          style: {
            $invisible: false,
            marginLeft: '0px'
          }
        },
        {
          if: (showCatalog, showEditor, selectedItem, showImportPla) =>
            !showCatalog && !showImportPla && (!showEditor || selectedItem == null),
          style: {
            $invisible: true,
            marginLeft: (elem) => `${-(elem.offsetWidth || 40)}px`
          }
        }
      ]
    });

    /* Save Delete Buttons */
    anim.register(this.$.saveDeleteHeaderButtons, {
      observer: 'showEditor, creatingItem, selectedItem, categoryDetails.showList',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(128px)' }
        },
        {
          if: (showEditor, creatingItem, selectedItem, categoryShowList) =>
            showEditor && (selectedItem != null || !categoryShowList) && !creatingItem,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.previewAssessmentButton, {
      observer: 'showEditor, creatingItem, selectedItem, unsavedChanges, externalChanges, category',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (showEditor, creatingItem, selectedItem, unsavedChanges, externalChanges, category) =>
            showEditor && !creatingItem && selectedItem != null && !unsavedChanges && !externalChanges && category == 'mobile_assessments',
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.downloadExportPreviewButton, {
      observer: 'showEditor, creatingItem, selectedItem, unsavedChanges, externalChanges, category',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (showEditor, creatingItem, selectedItem, unsavedChanges, externalChanges, category) =>
            showEditor && !creatingItem && selectedItem != null && !externalChanges && category == 'configurable_exports',
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.overwriteLayerButton, {
      observer: 'showEditor, creatingItem, selectedItem, selectedItemData, unsavedChanges, externalChanges, category',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (category) => category != 'reference_layers',
          style: { marginLeft: (elem) => `${-(elem.offsetWidth || 140)}px` }
        },
        {
          if: (showEditor, creatingItem, selectedItem, selectedItemData, unsavedChanges, externalChanges, category) => {
            return (
              showEditor &&
              !creatingItem &&
              selectedItem != null &&
              !unsavedChanges &&
              !externalChanges &&
              category == 'reference_layers' &&
              !selectedItemData.isJobSlicingLayer
            );
          },
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.createHeaderButtons, {
      observer: 'category, showEditor, creatingItem, selectedItem',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (category, showEditor, creatingItem, selectedItem) =>
            ['photo_forms', 'portal_app_types', 'configurable_exports'].includes(category) &&
            showEditor &&
            selectedItem != null &&
            creatingItem,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.reorderHeaderButton, {
      observer: 'category, showEditor, showCatalog, selectedItem, editingOrder, creatingItem, showImportPla',
      rules: [
        {
          if: true,
          style: { $invisible: false, transform: 'none' }
        },
        {
          if: (category, showEditor, showCatalog, selectedItem, editingOrder, creatingItem, showImportPla) =>
            !['toolsets', 'photo_toolsets', 'clearance_rules'].includes(category) || editingOrder,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (category, showEditor, showCatalog, selectedItem, editingOrder, creatingItem, showImportPla) =>
            showCatalog || showImportPla || (showEditor && selectedItem != null) || creatingItem,
          style: { $invisible: true, transform: 'translateX(-128px)' }
        }
      ]
    });

    anim.register(this.$.saveCancelReorderHeaderButtons, {
      observer: 'editingOrder',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (editingOrder) => editingOrder,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.saveItemButton, {
      observer: 'externalChanges, unsavedChanges, category, hideSaveButton',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (externalChanges, unsavedChanges, category, hideSaveButton) =>
            !externalChanges && !unsavedChanges && ['reference_layers', 'mobile_assessments'].includes(category),
          style: { marginLeft: (elem) => `${-(elem.offsetWidth || 90)}px` }
        },
        {
          if: (externalChanges, unsavedChanges, category, hideSaveButton) => !hideSaveButton && (externalChanges || unsavedChanges),
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.deleteItemButton, {
      observer: 'categoryDetails.showList',
      rules: [
        {
          if: true,
          style: { $invisible: false, marginRight: '0px' }
        },
        {
          if: (categoryShowList) => !categoryShowList,
          style: { $invisible: true, marginRight: (elem) => `-${elem.offsetWidth || 108}px` }
        }
      ]
    });

    /* Update Workspace Views */
    anim.register(this.$.newItemNameContainer, {
      observer: 'creatingItem, showEditor, selectedItem, categoryDetails.showEditor',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(128px)' }
        },
        {
          if: (creatingItem, showEditor, selectedItem) => creatingItem && showEditor && selectedItem != null,
          style: { $invisible: true, transform: 'translateY(-128px)' }
        },
        {
          if: (creatingItem, showEditor, selectedItem, categoryShowEditor) =>
            creatingItem && !showEditor && selectedItem == null && categoryShowEditor,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.editingContainer, {
      observer: 'creatingItem, showEditor, selectedItem, categoryDetails.showList',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(128px)' }
        },
        {
          if: (creatingItem, showEditor, selectedItem) => creatingItem && showEditor && selectedItem == null,
          style: { transform: 'translateY(128px)' }
        },
        {
          if: (creatingItem, showEditor, selectedItem, categoryShowList) => showEditor && (selectedItem != null || !categoryShowList),
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.listLayoutContainer, {
      observer: 'creatingItem, showEditor, selectedItem, categoryDetails.showList, categoryDetails.showEditor, showImportPla, showCatalog',
      rules: [
        {
          if: true,
          style: { $invisible: false, transform: 'none' }
        },
        {
          if: (creatingItem, showEditor, selectedItem, categoryShowList, categoryShowEditor, showImportPla, showCatalog) =>
            (!categoryShowList && !showCatalog) ||
            (creatingItem && categoryShowEditor) ||
            (showEditor && selectedItem != null) ||
            showImportPla,
          style: { $invisible: true, transform: 'translateX(128px)' }
        }
      ]
    });

    anim.register(this.$.sideContainer, {
      observer: 'showListFilters, showCatalog',
      rules: [
        {
          if: true,
          style: { width: '0px' }
        },
        {
          if: (showListFilters, showCatalog) => showListFilters,
          style: { width: () => `${this.$.listFilterLayoutContainer.offsetWidth || 205}px` }
        },
        {
          if: (showListFilters, showCatalog) => showCatalog,
          style: { width: () => `${this.$.catalogCategoryContainer.offsetWidth}px` }
        }
      ]
    });

    anim.register(this.$.listFilterLayoutContainer, {
      observer: 'showListFilters',
      rules: [
        {
          if: true,
          style: { $invisible: true }
        },
        {
          if: (showListFilters) => showListFilters,
          style: { $invisible: false }
        }
      ]
    });

    // anim.register(this.$.catalogCategoryContainer, {
    //   observer: 'showCatalog, selectedCatalog',
    //   rules: [{
    //     if: true,
    //     style: {transform: 'none'}
    //   }, {
    //     if: (showCatalog, selectedCatalog) => showCatalog && !selectedCatalog,
    //     style: {transform: 'translateY(10px)'}
    //   }]
    // });

    anim.register(this.$.catalogCategoryContainer, {
      observer: 'showCatalog, selectedCatalog',
      rules: [
        {
          if: true,
          style: { $invisible: true, paddingTop: '0px' }
        },
        {
          if: (showCatalog) => showCatalog,
          style: { $invisible: false }
        },
        {
          if: (showCatalog, selectedCatalog) => !selectedCatalog,
          style: { paddingTop: '25%' }
        }
      ]
    });

    anim.register(this.$.listContainer, {
      observer: 'showCatalog, selectedCatalog',
      rules: [
        {
          if: true,
          style: { $invisible: false, marginRight: null, marginLeft: null }
        },
        {
          if: (showCatalog, selectedCatalog, showImportPla) => showCatalog && !selectedCatalog,
          style: { $invisible: true, marginRight: (elem) => `-${elem.offsetWidth}px`, marginLeft: '0px' }
        }
      ]
    });

    anim.register(this.$.rightSideContainer, {
      observer: 'showCatalog, selectedCatalog',
      rules: [
        {
          if: true,
          style: { $invisible: false, marginRight: null, marginLeft: null }
        },
        {
          if: (showCatalog, selectedCatalog, showImportPla) =>
            (showCatalog && !selectedCatalog) || !selectedCatalog?.description || !showCatalog,
          style: { $invisible: true, marginRight: (elem) => `-${elem.offsetWidth}px`, marginLeft: '0px' }
        }
      ]
    });
  }

  async addCatalogCategoryItemToModelSpace(e) {
    this.catalogCategoryToAddDetails = this.catalogCategoryDetails;
    this.catalogCategoryItemToAdd = e.model.item.$key;
    e.model.set('item.$adding', true);
    await this.importFromCatalog().finally(() => {
      e.model.set('item.$adding', false);
    });
  }

  async importFromCatalog() {
    this.set('selectedCatalog.$adding', true);
    let options = {
      catalog: this.selectedCatalog.$key,
      modelSpace: this.modelSpaceDetails.$key,
      category: this.get('catalogCategoryToAddDetails.category'),
      item: this.catalogCategoryItemToAdd
    };

    // Set filtered catalog data if importing by tag so data is not fetched from firebase.
    if (this.catalogImportTags?.length) {
      options.catalogData = this.filteredCatalogData;
      if (options.category) {
        options.categoryData = Path.get(this.filteredCatalogData, this.catalogCategoryToAddDetails?.path?.replace(/models\//, ''), '/');
        if (options.item) options.itemData = Path.get(options.categoryData, options.item);
      }
    }

    let categoryPath = this.get('catalogCategoryToAddDetails.path');

    // Get the data to import from the catalog
    let update = await this.$.catalogImporter.import(options);

    // If we are importing a single item, store it's current data so we can allow the user to undo the import
    if (options.item && categoryPath && this.modelSpaceDetails.path) {
      let temp = {
        item: options.item,
        path: `${this.modelSpaceDetails.path}/${categoryPath}/${options.item}`
      };
      temp.data = await FirebaseWorker.ref(temp.path)
        .once('value')
        .then((s) => s.val());

      // Check if we are going to overwrite an existing item and warn the user
      if (temp.data != null) {
        const dialog = KatapultDialog.confirm({
          dialog: {
            title: 'Overwrite Existing Item?',
            color: 'var(--paper-red-500)'
          },
          body: `Importing ${temp.item} will overwrite the existing item in your model. Are you sure you want to continue?`,
          confirmButton: { label: 'Overwrite' }
        });
        const didConfirm = await dialog.confirmed;

        // If the user cancelled, return
        if (!didConfirm) {
          this.set('selectedCatalog.$adding', false);
          return;
        }
      }

      this.lastCatalogCategoryItemDetails = temp;
    }

    // Remove any reference to the toolset this tool was in for the model it was added from
    const updatePath = Object.keys(update || {})[0];
    if (options.category == 'tools' && update) delete update[updatePath].toolsets;

    // Do a large update because you could be importing an entire model or catalog
    await LargeUpdate(FirebaseWorker.ref(), update)
      .then(() => {
        this.$.confirmAddCatalogToModelSpaceDialog.close();
      })
      .catch((err) => {})
      .finally(() => {
        this.set('selectedCatalog.$adding', false);
      });
  }

  // TODO: There's a bug where copying a portal app type edits the original item which is bad, bad, bad. This is a temporary fix to prevent users from corrupting their portal config until there's an actual fix.
  showCopyButton(category) {
    if (!category || category == 'portal_app_types') return false;
    return true;
  }

  async copyItem() {
    if (this.selectedItemData) {
      // Create a copy of the selected item data to use for the copied item.
      let itemData = Path.copy(this.selectedItemData);
      // Clear the currently selected item so we can begin creating a new one.
      if (await this.clearSelectedItem(true)) {
        // Create a new item from the itemData.
        this.createItem(itemData);
      }
    }
  }

  async downloadItem() {
    await this.editor.download();
  }

  editorDomChange(e) {
    if (e.currentTarget.if) this.editorRenderFlag = !this.editorRenderFlag;
  }

  ensureModelSpaceExists() {
    if (!this.catalogDataLoading && !this.modelOptionsLoading && Array.isArray(this.modelSpaceOptions)) {
      if (this.modelSpaceOptions.find((x) => x.$key == this.modelSpace) == null) {
        this.setModelSpace(null, true);
      }
    }
  }

  exitCreateItem(e) {
    if (this.creatingItem) {
      this._setCreatingItem(false);
      // Clear the new item name.
      this.setNewItemName();
      // Clear any data used in creating the new item.
      this.newItemData = null;
      // Tell the editor we are no longer creating a new item.
      this.editor.exitCreateItem();
      // If this is a sub workspace, notify to the parent that we could like to close.
      if (this.hasParentWorkspace) this.dispatchEvent(new CustomEvent('close-request'));
    }
  }

  updateEditorEditingItem() {
    if (this.editor && this.editor instanceof KatapultEditorTemplate && this.categoryDetails) {
      const key = this.categoryDetails.showList ? this.selectedItem : this.categoryDetails.category;
      const data = this.categoryDetails.showList ? this.selectedItemData : this.categoryData;
      const modelSpaceChanged = this.editorModelSpace != this.modelSpaceDetails?.$key;
      // Set the item fully if we have changed the item or if the data was null and now is not. (or if in the Proposed Cable Logic section)
      // TODO: Remove the `proposed_cable_logic` check once Model Editor's indeterminate data loading state issues are resolved.
      if (
        this.editor.itemKey != key ||
        ['proposed_cable_logic', 'mobile_options', 'default_specs'].includes(key) ||
        this.editor.getInternalItemData() == null
      ) {
        this.editor.setItem(key, data ?? null);
      } else {
        this.editor.setItemData(data, key == null || modelSpaceChanged);
      }
      // Check to see if model space changed.
      if (modelSpaceChanged) {
        this.editorModelSpace = this.modelSpaceDetails?.$key;
        this.editor._resetInternalItemData();
      }
      if (!this.categoryDetails.showList && this.categoryDetails.showEditor) this._setShowEditor(true);
    }
  }

  updateCatalogCategoryDataArray() {
    if (this.catalogCategory) {
      // set the category path to get the categoryData from
      const basePath = this.get('catalogCategoryDetails.path');
      if (!basePath) return;
      // Split the path by slashes
      let catalogPathParts = basePath.split('/');
      // since the filteredCatalogData is already at the models level (because of permissions), we need to remove the "models" portion of the catalogCategoryDetails path, if it's there
      const catalogPathWithoutModels = catalogPathParts.filter((part) => part != 'models');
      const catalogPath = catalogPathWithoutModels.join('.');
      // get the category data
      let categoryData = Path.copy(this.get(`filteredCatalogData.${catalogPath}`));
      for (let key in categoryData) {
        if (typeof categoryData[key] != 'object') categoryData[key] = {};
        categoryData[key].$key = key;
        categoryData[key].$label = this.calcItemLabel(categoryData[key], this.catalogCategory);
        let modelSpaceItem = this.get(`catalogCategoryModelSpaceData.${key}`);
        categoryData[key].$upToDate = this.calcItemUpToDate(modelSpaceItem, categoryData[key]);
        categoryData[key].$outOfDate = this.calcItemOutOfDate(modelSpaceItem, categoryData[key]);
        categoryData[key].$icon = categoryData[key].icon;
        categoryData[key].$iconColor = categoryData[key].color;
        categoryData[key].$tags = getItemTags(this.catalogCategory, categoryData[key]);
      }
      let temp = ToArray(categoryData);

      if (this.get('catalogCategoryDetails.filter') != null) {
        temp = temp.filter(this.catalogCategoryDetails.filter);
      }

      if (this.get('catalogCategoryDetails.sortPath') != null) {
        temp.sort((a, b) => Path.get(a, this.categoryDetails.sortPath) - Path.get(b, this.categoryDetails.sortPath));
      } else {
        temp.sort((a, b) => a.$label.localeCompare(b.$label));
      }
      this.catalogCategoryDataArray = temp;
    } else {
      this.catalogCategoryDataArray = [];
    }
  }

  updateModelSpaceDetails() {
    let details;
    if (Array.isArray(this.modelSpaceOptions)) details = this.modelSpaceOptions.find((x) => x.$key == this.modelSpace);
    if (details === undefined) details = null;
    if (Path.get(this.modelSpaceDetails, '$key') != Path.get(details, '$key')) {
      // If we switch models, clear undo details for last imported item.
      this.lastCatalogCategoryItemDetails = null;
    }
    this._setModelSpaceDetails(details);
  }

  // HACK: This hides the following legacy catalogs from companies on the 2024 pricing.
  ignoreDueTo2024Pricing(catalog) {
    const has2024Pricing = ['data_collection_offering_2024', 'make_ready_engineering_offering_2024'].some((x) => this.companyModules?.[x]);
    if (!has2024Pricing) return false;
    const catalogsToIgnore = ['data_collection', 'make_ready', 'integrated_pole_loading', 'pla_exports'];
    return catalogsToIgnore.includes(catalog);
  }

  updateModelSpaceOptions() {
    let options = [];
    for (const key in this.catalogsData) {
      const catalog = this.catalogsData[key];
      // if this catalog has a module associated to it, check that the company has access to that module
      if (catalog.module != null && this.companyModules?.[catalog.module] == null) continue;
      // HACK: Hides legacy catalogs from companies on the 2024 pricing.
      if (this.ignoreDueTo2024Pricing(key)) continue;
      // this is a generic module and can be given to everyone
      options.push({
        catalog: true,
        type: 'Catalog',
        typeLowercase: 'catalog',
        label: catalog.name,
        description: catalog.description,
        $key: key,
        path: `photoheight/catalogs/${key}`,
        icon: 'communication:import-contacts',
        icons: [{ icon: 'communication:import-contacts', size: 24 }]
      });
    }
    if (this.modelOptions != null) {
      for (let key in this.modelOptions) {
        let modelSpace = this.modelOptions[key];
        const item = {
          modelSpace: true,
          type: 'Model',
          shared: modelSpace.shared,
          typeLowercase: 'model',
          label: modelSpace.label,
          $key: modelSpace.value,
          path: `photoheight/company_space/${modelSpace.value}`,
          icon: 'group-work',
          icons: [{ icon: 'group-work', size: 24 }]
        };
        // Override icons if shared.
        if (modelSpace.shared) {
          item.icon = 'social:public';
          item.icons = [{ icon: 'social:public', size: 24 }];
        }
        options.push(item);
      }
    } else if (this.userGroup && this.userCompanyName) {
      options.push({
        modelSpace: true,
        type: 'Model',
        typeLowercase: 'model',
        label: this.userCompanyName,
        $key: this.userGroup,
        path: `photoheight/company_space/${this.userGroup}`,
        icon: 'group-work',
        icons: [{ icon: 'group-work', size: 24 }]
      });
    }
    this._setModelSpaceOptions(
      options.sort((a, b) => {
        if (a.modelSpace && !b.modelSpace) return -1;
        else if (!a.modelSpace && b.modelSpace) return 1;
        else return a.label.localeCompare(b.label);
      })
    );
    this._setModelSpaceChooserOptions(
      this.modelSpaceOptions.filter((x) => {
        return x.modelSpace || this.userGroup === 'katapult';
      })
    );
    this._setCatalogOptions(
      options
        .sort((a, b) => {
          if (a.catalog && !b.catalog) return -1;
          else if (!a.catalog && b.catalog) return 1;
          else return a.label.localeCompare(b.label);
        })
        .filter((x) => {
          return x.$key != this.modelSpace && !x.shared;
        })
    );
  }

  updateRenderEditor() {
    if (this.showEditor) {
      setTimeout(() => {
        this._setRenderEditor(true);
      });
    } else {
      this._setRenderEditor(false);
    }
  }

  updateShowEditabilityColumn() {
    this.showEditabilityColumn =
      this.showEditabilityIcons && Array.isArray(this.filteredListItems) && this.filteredListItems.some((x) => x.editability != null);
  }

  updateCategoryDataArray() {
    if (this.categoryDetails?.showList) {
      if (!this.editingOrder || !this.editingOrderInitialized) {
        // Set order initialized flag if applicable.
        if (this.editingOrder) this._setEditingOrderInitialized(true);

        let temp = ToArray(this.categoryData);

        // Filter list items.
        if (this.get('categoryDetails.filter') != null) {
          temp = temp.filter(this.categoryDetails.filter);
        }

        // Sort list items.
        if (this.get('categoryDetails.sortPath') != null) {
          temp.sort((a, b) => {
            const aVal = Path.get(a, this.categoryDetails.sortPath) ?? null;
            const bVal = Path.get(b, this.categoryDetails.sortPath) ?? null;
            return aVal - bVal;
          });
        } else {
          temp.sort((a, b) => a?.$label?.localeCompare(b?.$label));
        }

        if (this.get('categoryDetails.sortReverse')) temp.reverse();

        this.categoryDataArray = temp;
      }
    } else {
      this.categoryDataArray = [];
    }
  }

  updateCategoryDetails() {
    this._setCategoryDetails(this.getCategoryDetails(this.category));
    this._setCatalogCategoryDetails(this.getCategoryDetails(this.catalogCategory));
    this._setShowEditor(!this.categoryDetails?.showList);
  }

  updateListLoading() {
    let wasLoading = this.listLoading;
    this.listLoading =
      (this.showCatalog && (this.catalogDataLoading || this.catalogCategoryModelSpaceDataLoading)) ||
      (!this.showCatalog && this.categoryDataLoading) ||
      this.forceShowListLoading;
    if (wasLoading && !this.listLoading) setTimeout(() => this.$.listSearchInput.focus());
  }

  getProperty(item) {
    return Path.get(item, Array.from(arguments).slice(1).join('.'));
  }

  coloredLabels(item) {
    return this.get(`extraCategoryData.labels.${item}.color`) != 'white';
  }

  hasOverheadUsers(itemUsers, users) {
    return itemUsers?.some((x) => users?.[x.uid]?.employment?.overhead_employee);
  }

  calcItemLabel(item, category) {
    let label;
    if (this.editor?.computedLabel?.compute) label = this.editor.getComputedLabel(item).label;
    if (label == null) {
      switch (category) {
        case 'clearance_rules':
          label = CamelCase(item.shorthand);
          break;
        case 'photo_forms':
        case 'map_print_templates':
        case 'saved_view_templates':
        case 'time_categories':
        case 'reference_layers':
        case 'files':
          label = item.name;
          break;
        case 'photo_routines':
        case 'construction_specs':
          label = item.name ?? CamelCase(item.$key);
          break;
        case 'photo_elements':
          label = item.name ?? CamelCase(item.$key);
          break;
        case 'compatible_unit_automations':
          label = item.name;
          break;
        case 'mobile_assessments':
        case 'tools':
          label = item.label != null ? item.label : CamelCase(item.$key);
          break;
        case 'portal_app_types':
          label = item.display_name;
          break;
        case 'pole_specs':
          label = item.pole_spec;
          break;
        case 'wire_specs':
        case 'dds_bundles':
          label = item.wire_spec;
          break;
        case 'anchor_specs':
          label = item.anchor_spec;
          break;
        case 'insulator_specs':
          label = item.insulator_spec;
          break;
        case 'arm_specs':
          label = item.arm_spec;
          break;
        case 'equipment_specs':
          label = `${item.equipment_spec} ${CamelCase(item.equipment_type)}`;
          break;
        case 'compatible_units':
          label = item.cu;
          break;
        case 'api_layers':
          label = item.name;
          break;
        default:
          label = CamelCase(item.$key);
      }
    }
    // Ensure label is empty string and not null.
    if (label == null) label = '';
    // Make sure label is firebase decoded.
    label = FirebaseEncode.decode(label);
    return label;
  }

  calcItemLastModifed(item, catalogItem, comparison) {
    if (item != null) {
      let lastModified = item.last_modified || item._last_modified;
      let catalogLastModified = catalogItem.last_modified || catalogItem._last_modified;
      if (comparison == 'up_to_date') return catalogLastModified == null || lastModified >= catalogLastModified;
      if (comparison == 'out_of_date') return catalogLastModified != null && lastModified < catalogLastModified;
    }
  }

  calcItemUpToDate(item, catalogItem) {
    return this.calcItemLastModifed(item, catalogItem, 'up_to_date');
  }

  calcItemOutOfDate(item, catalogItem) {
    return this.calcItemLastModifed(item, catalogItem, 'out_of_date');
  }

  updateNewItemKeyExists() {
    this.newItemKeyExists =
      this.newItemKey != null &&
      (this.get(`categoryData.${this.newItemKey}`) != null ||
        (this.get(`categoryDetails.category`) == 'photo_routines' && this.get(`inputModels.${this.newItemKey}`) != null));
    this.newItemNameErrorMessage = this.newItemKeyExists
      ? `${this.itemTypeTitles.article} ${this.itemTypeTitles.lowercaseTitle} with this name already exists`
      : '';
  }

  activeCategoryChanged() {
    let category = this.showCatalog ? this.catalogCategory : this.category;
    let categoryDetails = this.getCategoryDetails(category);
    if (categoryDetails != null) {
      this.listItemTitles = {
        title: categoryDetails.title,
        titleSingular: pluralize(categoryDetails.title, 1)
      };
    }
    this.showEditabilityIcons = ['attributes', 'photo_elements'].some((attribute) => Path.get(categoryDetails, 'category') == attribute);
    this.showListIcons = ['tools', 'files', 'custom_icons', 'time_categories'].includes(Path.get(categoryDetails, 'category'));
    if (this.category == 'files') import('@katapult/s-circle-progress/s-circle-progress.js');
  }

  cancelEditOrder() {
    this._setEditingOrder(false);
    this._setEditingOrderInitialized(false);
  }

  cancelImportPla() {
    this.setShowImportPla(false);
  }

  cancelRenameItem() {
    this.clearSelectedItem(true);
    this.$.renameItemDialog.close();
  }

  categoryDataChanged(value) {
    if (this.categoryDetails?.showList) {
      for (let key in value) {
        // If the value is not an object, or it's null, make it an object so we can set a key on it so it will show up in the list
        if (value[key] == null || typeof value[key] != 'object') value[key] = {};
        let item = value[key];
        item.$key = key; // Initialize key (will get set my ToArray in a bit, but we need it to be set earlier otherwise it doesn't exist in itemData passed to editor on page load if an item is selected in the hash).
        item.$label = this.calcItemLabel(item, this.category);
        if (item.icon) {
          item.$icon = item.icon;
          item.$iconColor = item.color;
        }
        item.$tags = getItemTags(this.category, item);
        if (this.category == 'files') {
          if (item.status == 'uploading') {
            item.$showProgress = true;
            item.$progress = item.upload_progress;
          } else if (item.status == 'failed') {
            item.$icon = 'error';
            item.$iconColor = 'var(--paper-red-500)';
          }
          if (item.size != null) item.$size = FormatSize(item.size);
          if (item.upload_date) item.$upload_date = FormatDate(item.upload_date);
        }
        if (this.category == 'time_categories' && item.archived === true) {
          item.$icon = 'archive';
          item.$icon_tooltip = 'This category is archived';
        }
      }
    }
    this.categoryData = value;
  }

  categoryDataSortChanged(e) {
    let removedItem = this.categoryDataArray.splice(e.detail.prevIndex, 1)[0];
    this.categoryDataArray.splice(e.detail.index, 0, removedItem);
    this.notifySplices(`categoryDataArray`, [
      { index: e.detail.prevIndex, removed: [removedItem], addedCount: 0 },
      { index: e.detail.index, removed: [], addedCount: 1 }
    ]);
  }

  async clearSelectedItem(forcefully) {
    return this.setSelectedItem(null, forcefully);
  }

  async clearSelectedItemForcefully() {
    return this.clearSelectedItem(true);
  }

  clearListSearch() {
    this.listSearchText = '';
  }

  clickCatalogCategory(e) {
    this._setCatalogCategory(e.model.item.category);
  }

  listItemClickHandler(e) {
    let contextMenu = false;
    let contextMenuWasOpened = this.itemContextMenuOpened;
    if (e.type == 'contextmenu') {
      e.preventDefault();
      contextMenu = true;
    } else if (!this.categoryDetails.showEditor) {
      contextMenu = true;
    }
    // Make sure context menu dialogs are closed.
    this.$.renameItemDialog.close();
    this.$.deleteItemDialog.close();
    // If we are not going to open the context menu, make sure that it is closed.
    if (!contextMenu) this.closeItemContextMenu();
    if (!this.editingOrder && !this.showCatalog) {
      let forcefully = true; //contextMenu || contextMenuWasOpened;
      this.editSelectedItem(e, contextMenu);
      this.setSelectedItem(e.model.item.$key, forcefully);
    }
  }

  closeItemContextMenu() {
    if (this.itemContextMenuOpened) {
      this.$.itemContextMenu.style.opacity = 0;
      this.$.itemContextMenu.style.pointerEvents = 'none';
      this.$.itemContextMenu.style.transform = 'translateY(12px)';
      setTimeout(() => {
        this.$.itemContextMenu.style.transition = 'none';
      }, 100);
      this.itemContextMenuOpened = false;
    }
  }

  closeSubWorkspace() {
    this._setShowSubWorkspace(false);
  }

  complexSearch(item, searchText) {
    if (this.category == 'time_categories') {
      return item.users?.some((x) => x.email.includes(searchText));
    } else if (this.category == 'compatible_units') {
      return (
        item?.description?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        item?.tags?.toLowerCase()?.includes(searchText?.toLowerCase())
      );
    } else if (this.category == 'compatible_unit_automations') {
      // create a list of attributes that we can search
      let attributesToSearchBy = ['tag', 'grouping', 'type', 'cable_type', 'marker_type'];
      let queryResults = [];
      // loop through the list and add the results
      for (let attributeToSearchBy of attributesToSearchBy) {
        let itemData = item[attributeToSearchBy]?.toLowerCase();
        if (itemData) queryResults.push(itemData.includes(searchText));
      }
      return queryResults.some((x) => x);
    }
  }

  confirmRenameItem() {
    this.saveItem().then((success) => {
      if (success) {
        this.$.renameItemDialog.close();
      }
    });
  }

  createItem(data) {
    let editor = this.editor;
    // Ignore first param if it is an event.
    if (data instanceof Event) data = undefined;
    // Store the data to reference later.
    this.createItemData = data ?? null;
    // Enable workspace editing mode.
    this._setCreatingItem(true);
    // Notify editor to enter editing mode.
    editor.createItem();

    // Check to see if the editor should render all creation steps by default
    if (editor.skipCreationSteps) editor.skipSteps();

    // Determine labeling of the new item
    if (editor.computedLabel) {
      this.setNewItemName(editor.getComputedLabel().label);
      this.editNewItem();
    } else if (data?.$label) {
      this.setNewItemName(data.$label);
      this.editNewItem();
      editor.skipSteps();
    } else {
      // Focus the name input.
      this.$.newItemNameInput.focus();
    }
  }

  async deleteItem(forcefully) {
    if (forcefully !== true) {
      this.$.deleteItemDialog.open();
    } else {
      this.deletingItem = true;
      this.deletedItemTitle = this.selectedItemTitle;
      await this.editor
        .delete()
        .then(() => {
          this.$.deleteItemDialog.close();
          this.showDeletedOverlay = true;
          setTimeout(() => {
            this.showDeletedOverlay = false;
            this.clearSelectedItem(true);
          }, 2000);
        })
        .catch((err) => {
          console.log('ERROR WITH DELETING', err);
        })
        .finally(() => {
          this.deletingItem = false;
        });
    }
  }

  deleteItemForcefully() {
    this.deleteItem(true);
  }

  editorItemSet(e) {
    if (e.detail.itemKey != this.selectedItem && this.categoryDetails?.showList) {
      this.setSelectedItem(e.detail.itemKey, true);
    }
  }

  editSelectedItem(e, contextMenu) {
    contextMenu = contextMenu || !this.categoryDetails?.showEditor;
    if (contextMenu) {
      if (e instanceof Event) this.openItemContextMenu(e);
      else console.warn('Could not open context menu for this item because event was not provided');
    } else {
      this._setShowEditor(true);
    }
  }

  async externalChangesButtonClicked(e) {
    let promise = this.externalChangesPromise;
    let res = false;
    if (e.currentTarget.hasAttribute('confirm')) {
      res = await this.saveItemForcefully();
    }
    if (promise) promise(res);
    this.$.externalChangesDialog.close();
  }

  async finishImportPla() {
    let models = this.$.plaImportWizard.modelSpaceConfig;
    if (models.parsedClientFile && models.clientFileImporter) {
      await models.clientFileImporter.writeImport(this.modelSpaceDetails.$key, models.parsedClientFile).catch((err) => console.log(err));
    }
    this.cancelImportPla();
  }

  getCategoryDetails(category) {
    return this.categories.find((x) => x.category == category);
  }

  get editor() {
    if (!this.signedIn) return null;

    let editor = this.shadowRoot.querySelector('#editor');
    if (editor == null) console.warn('Failed to find item editor');
    return editor;
  }

  getListItemSlot(editingOrder) {
    return editingOrder ? 'sortable' : 'before';
  }

  getSubWorkspace() {
    return this.shadowRoot.querySelector('#workspace');
  }

  itemContextMenuChanges() {
    if (
      this.itemContextMenuHasBeenOpened === true &&
      !this.itemContextMenuOpened &&
      !this.showEditor &&
      !this.renameItemDialogOpened &&
      !this.deleteItemDialogOpened
    ) {
      console.trace('SELECTED CONTEXT CLOSING');
      this.clearSelectedItem(true);
    }
  }

  async setShowImportPla(show) {
    if (!show || (await this.clearSelectedItem())) {
      this._setShowImportPla(show);
      if (show) {
        this.$.plaImportWizard.begin();
        this.clearListSearch();
        this.setShowCatalog(false);
      }
    }
  }

  newItemNameInputKeypress(e) {
    if (e.key == 'Enter') this.editNewItem();
  }

  openItemContextMenu(e) {
    this.$.itemContextMenu.style.top = e.clientY + 12 + 'px';
    this.$.itemContextMenu.style.left = e.clientX + 12 + 'px';
    setTimeout(() => {
      this.$.itemContextMenu.style.transition = 'all 0.1s';
      this.$.itemContextMenu.style.pointerEvents = 'auto';
      this.$.itemContextMenu.style.opacity = 1;
      this.$.itemContextMenu.style.transform = null;
    });
    this.itemContextMenuHasBeenOpened = this.itemContextMenuOpened = true;
  }

  openSubWorkspace(options) {
    if (this.subWorkspace == null) {
      this.subWorkspaceOptions = options;
      this._setShowSubWorkspace(true);
    }
  }

  promptAddCatalogCategoryToModelSpace(e) {
    e.stopPropagation();
    this.catalogCategoryToAddDetails = e.model.item;
    this.catalogCategoryItemToAdd = null;
    this.$.confirmAddCatalogToModelSpaceDialog.open();
  }

  promptAddCatalogToModelSpace() {
    this.catalogCategoryToAddDetails = null;
    this.catalogCategoryItemToAdd = null;
    this.$.confirmAddCatalogToModelSpaceDialog.open();
  }

  renameItem() {
    this.$.renameItemDialog.open();
  }

  async saveEditOrder() {
    if (!this.get('categoryDetails.firestore')) {
      let update = {};
      if (this.get('categoryDetails.sortPath') != null) {
        this.categoryDataArray.forEach((item, i) => {
          update[`${item.$key}/${this.categoryDetails.sortPath}`] = i;
        });
      }
      this.savingEditOrder = true;
      await FirebaseWorker.ref(this.categoryDataPath)
        .update(update)
        .then(() => {
          this.cancelEditOrder();
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.savingEditOrder = false;
        });
    }
  }

  async saveItem(forcefully) {
    if (this.selectedItem != null || !this.categoryDetails?.showList) {
      if (this.externalChanges && forcefully !== true && forcefully?.detail?.forcefully !== true) {
        this.$.externalChangesDialog.open();
        // Create a new promise who's resolve method is assigned to this.externalChangesPromise.
        let promise = new Promise((resolve) => {
          this.externalChangesPromise = resolve;
        });
        // Have promise clear this.externalChangesPromise upon resolving.
        promise.finally(() => (this.externalChangesPromise = null));
        // Return the promise for the caller of setSelectedItem to await.
        return promise;
      } else {
        this.savedItemTitle = this.selectedItemTitle;
        this.savingSelectedItem = true;
        // Tell the editor that we are saving.
        return this.editor
          .save()
          .then(() => {
            this.showSavedOverlay = true;
            setTimeout(() => (this.showSavedOverlay = false), 1000);
            // add in delay to allow animation above to happen
            if (this.creatingItem) setTimeout(() => this.exitCreateItem(), 1000);
            this.dispatchEvent(
              new CustomEvent('saved-item', { detail: { key: this.selectedItem, item: this.selectedItemData, category: this.category } })
            );
            return true;
          })
          .catch((err) => {
            console.log('ERROR WITH SAVING', err);
          })
          .finally(() => {
            this.savingSelectedItem = false;
          });
      }
    }
  }

  async saveItemForcefully() {
    return await this.saveItem(true);
  }

  async openAssessmentInSandbox() {
    let jobId = this.modelSpace + '_sandbox';
    // Make sure that job doesn't already exist.
    let jobAlreadyExists = await FirebaseWorker.ref(`photoheight/jobs/${jobId}`)
      .once('value')
      .then((s) => s.exists());
    if (!jobAlreadyExists) {
      let jobStyles = {};
      let mapStyles = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/models/map_styles`)
        .once('value')
        .then((s) => s.val());
      let defaultStyle = Object.values(mapStyles).find((style) => style._default);
      if (defaultStyle) jobStyles.default = defaultStyle;
      let newJob = {
        name: CamelCase(jobId),
        date_created: firebase.database.ServerValue.TIMESTAMP,
        job_creator: this.userGroup,
        job_owner: this.userGroup,
        sharing: { [this.userGroup]: 'write' },
        map_styles: jobStyles
      };
      await FirebaseWorker.ref(`photoheight/jobs/${jobId}`).update(newJob);
    }
    // Open the sandbox with the selected assessment button
    window.open(`../mobile/?button=${this.selectedItem}#${jobId}`);
  }

  async downloadPreviewExport(e) {
    let target = e.currentTarget;
    target.loading = true;
    this.editor
      .downloadPreviewExport()
      .then(() => {
        target.loading = false;
      })
      .catch((error) => {
        target.loading = false;
        KatapultDialog.alert({
          text: error.message,
          dialog: { color: 'var(--paper-red-500)', modal: true, title: 'Download Error' }
        });
        console.log('There was an error!', error.message);
        console.error(error);
      });
  }

  async updateReferenceLayer() {
    let editor = this.editor;
    if (
      await editor.confirm({
        title: 'Overwrite this layer?',
        body: 'All existing data will be deleted but references to this layer will remain the same in jobs.',
        confirmButtonText: 'Yes, Overwrite...'
      })
    ) {
      editor.overwritingLastModifiedTime = this.selectedItemData[editor.lastModifiedPath];
      editor._setCreatingItem(true);
      editor.checkSteps();
      editor._setCurrentIndex(0);
    }
  }

  async revertLastCatalogCategoryItem() {
    if (this.lastCatalogCategoryItemDetails) {
      this.revertingLastCatalogCategoryItem = true;
      await FirebaseWorker.ref(this.lastCatalogCategoryItemDetails.path).set(this.lastCatalogCategoryItemDetails.data);
      this.lastCatalogCategoryItemDetails = null;
      this.revertingLastCatalogCategoryItem = false;
    }
  }

  async setShowCatalog(show) {
    if (!show || (await this.clearSelectedItem())) {
      this._setShowCatalog(show);
      if (show) {
        this.clearListSearch();
        this.setShowImportPla(false);
      }
    }
  }

  editNewItem() {
    let creatingBlankItem = !this.createItemData;
    if (!creatingBlankItem || ((this.editor?.computedLabel || this.newItemNameValid) && !this.newItemKeyExists)) {
      let newItemData = creatingBlankItem ? {} : this.createItemData;
      newItemData.$label = this.newItemName;
      newItemData.$key = this.newItemKey;
      this.setSelectedItem(this.newItemKey, true);
      this.editor.setItem(this.newItemKey, null, newItemData);
      this._setShowEditor(true);
    }
    if (this.editor.skipCreationSteps) {
      setTimeout(() => this.editor.save(), 200);
    }
  }

  setupCatalogImporter() {
    let temp = this.shadowRoot.querySelector('#catalogImporter');
    if (temp) this.$.catalogImporter = temp;
  }

  setupPlaImporter() {
    // Find the importer.
    const temp = this.shadowRoot.querySelector('#plaImportWizard');
    // Make sure the importer exists and hasn't been setup yet.
    if (temp && this.$.plaImportWizard == null) {
      // Set the importer on the workspace.
      this.$.plaImportWizard = temp;
      // Register the importer with the animation manager.
      this._animationManager.register(this.$.plaImportWizard, {
        observer: 'showImportPla',
        rules: [
          {
            if: true,
            style: {
              $invisible: true,
              transform: 'translateX(-128px)'
            }
          },
          {
            if: (showImportPla) => showImportPla,
            style: {
              $invisible: false,
              transform: 'none'
            }
          }
        ]
      });
    }
  }

  startEditOrder() {
    this.clearListSearch();
    this._setEditingOrder(true);
  }

  subWorkspaceDomChange(e) {
    this.subWorkspace = this.getSubWorkspace();
    if (this.subWorkspace) {
      let options = this.subWorkspaceOptions || {};
      this.subWorkspace.setModelSpace(this.modelSpace);
      if (options.category) {
        this.subWorkspace.setCategory(options.category);
        setTimeout(() => {
          if (options.selectedItem) {
            this.subWorkspace.setSelectedItem(options.selectedItem);
            this.subWorkspace.editSelectedItem();
            let editor = this.subWorkspace.editor;
            if (editor) {
              editor.addEventListener('loading-changed', (e) => {
                if (!e.detail.value) editor.scrollToStep(options.focusStep);
              });
            }
          } else if (options.create) {
            this.subWorkspace.createItem();
          }
        });
      }
      this.subWorkspace.style.transform = 'none';
      this.subWorkspace.style.opacity = '1';
    }
  }

  updateCategoryDataPath() {
    if (
      this.get('categoryDetails.path') &&
      ((!this.get('categoryDetails.firestore') && this.get('modelSpaceDetails.path')) ||
        (this.get('categoryDetails.firestore') && this.get('modelSpaceDetails.$key')))
    ) {
      let categoryDataPath = null;
      if (this.categoryDetails.firestore) {
        categoryDataPath = `companies/${this.modelSpaceDetails.$key}/${this.categoryDetails.path}`;
      } else {
        categoryDataPath = Path.join([this.modelSpaceDetails.path, this.categoryDetails.path], '/');
      }
      // If we are going to change the category data path, delay 100 ms first to allow UI to update.
      this.forceShowListLoading = true;
      setTimeout(() => {
        this.categoryDataPath = categoryDataPath;
        setTimeout(() => {
          this.forceShowListLoading = false;
        });
      }, 100);

      // Unsubscribe
      if (this.categoryDataUnsubscribe) this.categoryDataUnsubscribe();
      if (this.categoryDataRef) this.categoryDataRef.off('value', this.categoryDataRef.listener);

      // Load the data
      if (this.categoryDetails.firestore) {
        this.categoryDataUnsubscribe = firebase
          .firestore()
          .collection(categoryDataPath)
          .onSnapshot((s) => {
            let categoryData = {};
            s.docs.forEach((doc) => {
              let item = {
                $key: doc.id,
                ...doc.data()
              };
              item.$label = this.calcItemLabel(item, this.category);
              categoryData[doc.id] = item;
            });
            this.categoryData = categoryData;
          });
      } else {
        this.categoryDataRef = FirebaseWorker.ref(categoryDataPath);
        this.categoryDataRef.listener = this.categoryDataRef.on('value', (s) => {
          this.categoryDataChanged(s.val());
        });
      }
    } else {
      this.categoryDataPath = null;
    }
  }

  updateCatalogCategoryModelSpaceDataPath() {
    if (this.get('modelSpaceDetails.path') && this.catalogCategory != null && this.catalogCategoryDetails != null) {
      let catalogCategoryModelSpaceDataPath = Path.join([this.modelSpaceDetails.path, 'models', this.catalogCategoryDetails.path], '/');
      // If we are going to change the category data path, delay 100 ms first to allow UI to update.
      if (this.catalogCategoryModelSpaceDataPath != catalogCategoryModelSpaceDataPath) {
        this.forceShowListLoading = true;
        setTimeout(() => {
          this.catalogCategoryModelSpaceDataPath = catalogCategoryModelSpaceDataPath;
          setTimeout(() => {
            this.forceShowListLoading = false;
          });
        }, 100);
      }
    } else {
      this.catalogCategoryModelSpaceDataPath = null;
    }
  }

  newItemNameInputChanged() {
    let res = this.setNewItemName(this.newItemNameInput);
    if (this.newItemName.length == 0) this.newItemNameErrorMessage = '';
    else if (res.error) this.newItemNameErrorMessage = res.error;
  }

  pendingChanges() {
    // If there are unsaved changes
    // or we are creating an item and have left the name item stage
    // or we are uploading files
    // return true.
    return this.unsavedChanges || (this.creatingItem && this.selectedItem != null) || this.uploadingFiles;
  }

  async permissionToDiscardChanges() {
    return !this.pendingChanges() || (await this.$.unsavedChangesDialog.open().then((x) => x?.hasAttribute('dialog-confirm')));
  }

  setCategory(category) {
    this.setView({ category });
  }

  setModelSpace(modelSpace, forcefully) {
    let options = { modelSpace, forcefully };
    // If we are switching model spaces to a model (not your own company), reset the category to attributes so company only categories are not left open
    if (this.userGroup != null && modelSpace != this.userGroup) {
      options.category = this.categories[0].category;
    }
    this.setView(options);
  }

  setNewItemName(name) {
    // Make sure the new name input is up to date.
    this.newItemNameInput = name;
    // Sanitize new item name.
    this.newItemName = (name || '').trim();
    const exists = this.newItemName.length > 0;
    const containsIllegalCharacters = ContainsIllegalCharacters(this.newItemName);
    // New item name is valid if we have a name and it doesn't contain illegal characters (or we don't care about illegal characters).
    const illegalCharactersViolation = containsIllegalCharacters && !this.editor?.labelAllowAllCharacters;
    this.newItemNameValid = exists && !illegalCharactersViolation;
    const res = { error: null };
    if (illegalCharactersViolation) res.error = `You may not use the following characters: ${IllegalCharacters.join(' ')}`;
    else {
      switch (this.category) {
        case 'clearance_rules':
        case 'pole_specs':
        case 'wire_specs':
        case 'anchor_specs':
        case 'insulator_specs':
        case 'arm_specs':
        case 'equipment_specs':
        case 'photo_routines':
        case 'construction_specs':
        case 'photo_elements':
        case 'sidewalk_brace_specs':
        case 'configurable_exports':
        case 'dds_bundles':
        case 'web_automations':
        case 'compatible_units':
        case 'compatible_unit_automations':
        case 'api_layers':
          // Generate a new item key.
          this.newItemKey = FirebaseWorker.ref().push().key;
          break;
        default:
          this.newItemKey = this.newItemNameValid ? NameToKey(this.newItemName) : null;
      }
    }
    return res;
  }

  async setSelectedItem(selectedItem, forcefully) {
    // Close sub workspace if it exists.
    if (this.subWorkspace != null) {
      const cleared = await this.subWorkspace.clearSelected();
      if (!cleared) return false;
    }
    // If the selected item is already the requested item, do nothing.
    if (this.selectedItem == selectedItem) return true;
    // If there are pending changes, require discard confirmation.
    if (!forcefully && !(await this.permissionToDiscardChanges())) return false;
    // Handle clearing the selected item.
    if ((this.selectedItem != null || this.creatingItem) && selectedItem == null && this.hasParentWorkspace) {
      this.dispatchEvent(new CustomEvent('close-request'));
    } else {
      // Clear any errors on the workspace title.
      this.$.workspaceTitle.invalid = false;
      this.$.workspaceTitle.errorMessage = null;
      this.$.workspaceTitle.errorMessage = null;
      this.$.workspaceTitle.errorMessage = null;
      // Set the selected item to be the selected item.
      this._setSelectedItem(selectedItem);
      // If we are in creating mode, exit it and notify editor.
      if (this.selectedItem == null) {
        this._setShowEditor(false);
        this.exitCreateItem();
      }
    }
    return true;
  }

  async setView(options) {
    options = options || {};

    let changingModelSpace = options.modelSpace !== undefined && options.modelSpace != this.modelSpace;
    let changingCateory = options.category !== undefined && options.category != this.category;

    if (this.uploadingFiles) this.$.busyUploadingDialog.open();
    // Before changing the category, we must make sure we can discard any pending changes.
    else if ((changingModelSpace || changingCateory) && (options.forcefully || (await this.permissionToDiscardChanges()))) {
      // If we have a selected list item, clear it.
      if (this.categoryDetails?.showList) this.clearSelectedItem(true);
      this.clearListSearch();
      if (this.editingOrder) this.cancelEditOrder();
      if (this.creatingItem) this.exitCreateItem();
      if (this.helpText) this.helpText = null;
      if (changingCateory) {
        // Clear current category data.
        this.categoryData = null;
        this._setCategory(options.category);
      }
      if (changingModelSpace) this._setModelSpace(options.modelSpace);
    }

    // if (this.pendingChanges() && forcefully !== true) {
    //   const discardChanges = await this.$.unsavedChangesDialog.open().then(x => x.hasAttribute('dialog-confirm'));
    //   if (!discardChanges) return false;
    // }
  }

  toggleAllTagsOnForEditors() {
    if (!this.visibleFilterTags || !this.allTags || !this.category) return;
    const category = this.showCatalog ? this.catalogCategory : this.category;
    const editorsToToggleOnAllTags = ['tools', 'photo_elements', 'attributes', 'photo_routines', 'construction_specs'];
    if (editorsToToggleOnAllTags.includes(category)) this.setStateForAllFilterTags(true);
  }

  someFilterTagIsChecked() {
    return this.visibleFilterTags?.some((tag) => tag.checked === true);
  }

  setStateForAllFilterTags(checked) {
    this.visibleFilterTags?.forEach((tag, tagIndex) => {
      this.set(`visibleFilterTags.${tagIndex}.checked`, checked);
    });
  }

  toggleAllFilterTagsHandler(e) {
    const checked = e.target.checked;
    this.setStateForAllFilterTags(checked);
  }

  subWorkspaceSavedItem(e) {
    if (this.category == 'toolsets' && e.detail.category == 'tools') this.editor.addTool(e.detail.key);
  }

  updateFilteredListItems() {
    const { listItems = [] } = this;

    if (this.editingOrder) {
      this.filteredListItems = listItems;
      return;
    }

    const category = this.showCatalog ? this.catalogCategory : this.category;

    // Sanitize search text.
    this.sanitizedListSearchText = this.listSearchText == null ? '' : this.listSearchText.toString().trim().toLowerCase();

    const checkedFilterTags = this.visibleFilterTags?.filter((tag) => tag.checked).map((tag) => tag._id) ?? [];
    const showItemsWithoutTags = checkedFilterTags.includes('no_tags');
    const categoryHasItemTags = this.categoryHasItemTags(category);

    const filteredListItems = listItems.filter((item) => {
      // Sanitize label.
      const label = item.$label ?? '';
      const sanitizedLabel = label.trim().toLowerCase();
      const labelMatchesSearchText =
        sanitizedLabel.includes(this.sanitizedListSearchText) || this.complexSearch(item, this.sanitizedListSearchText);

      // Apply the filters to the items
      const itemTags = item.$tags ?? [];
      const hasSomeTagMatchingTagFilter = checkedFilterTags.some((tagId) => itemTags.includes(tagId));

      // Always include items with no tags
      const itemHasNoTagsAndPassesNoTagsFilter = itemTags.length == 0 && (!categoryHasItemTags || showItemsWithoutTags);
      // Check to see if the item should be filtered out based on the tags that it has and the filters that are checked.
      const shouldShowItemWithFilter = itemHasNoTagsAndPassesNoTagsFilter || hasSomeTagMatchingTagFilter;

      return labelMatchesSearchText && shouldShowItemWithFilter;
    });

    this.filteredListItems = filteredListItems;
  }

  categoryHasItemTags(category) {
    return category != null && DEFAULT_ITEM_TAG_MAP[category] != null;
  }

  updateListItems() {
    let temp;
    if (this.showCatalog) {
      temp = this.catalogCategoryDataArray;
    } else {
      temp = this.categoryDataArray;
    }
    this.listItems = Array.isArray(temp) ? [...temp] : [];
  }

  updateCatalogCategories() {
    if (this.filteredCatalogData) {
      this.catalogCategories = this.categories.filter((category) => {
        if (!category.path) return false;
        // Split the path by slashes
        let catalogPathParts = category.path.split('/');
        // since the filteredCatalogData is already at the models level (because of permissions), we need to remove the "models" portion of the catalogCategoryDetails path, if it's there
        const catalogPathWithoutModels = catalogPathParts.filter((part) => part != 'models');
        const catalogPath = catalogPathWithoutModels.join('.');
        // Check if the catalog has data at the new path.
        return this.get(`filteredCatalogData.${catalogPath}`) != null;
      });
      if (this.selectedCatalog && this.prevSelectedCatalogKey !== this.selectedCatalog.$key && this.catalogCategories.length > 0) {
        this._setCatalogCategory(this.catalogCategories[0].category);
        this.prevSelectedCatalogKey = this.selectedCatalog.$key;
      }
    } else {
      this.catalogCategories = [];
    }
  }

  updateCatalogDataPath() {
    let path = null;
    if (this.get('selectedCatalog.modelSpace')) {
      path = `photoheight/company_space/${this.selectedCatalog.$key}/models`;
    } else if (this.get('selectedCatalog.catalog')) {
      path = `photoheight/catalogs/${this.selectedCatalog.$key}/models`;
    }
    this.catalogDataPath = path;
  }

  async updateExtraCategoryData(category, userGroup) {
    if (userGroup) {
      if (category == 'time_categories') {
        this.extraCategoryData = {
          labels: await FirebaseWorker.ref(`photoheight/company_space/${userGroup}/project_tracking/labels`)
            .once('value')
            .then((s) => s.val()),
          users: await FirebaseWorker.ref(`photoheight/company_space/${userGroup}/users`)
            .once('value')
            .then((s) => s.val())
        };
      } else {
        this.extraCategoryData = null;
      }
    }
  }

  updateSelectedItemData() {
    let selectedItemData = this.get(`categoryData.${this.selectedItem}`);
    // Use item data from categoryData if it exists.
    if (selectedItemData !== undefined) {
      this._setSelectedItemData(selectedItemData);
    } else {
      this._setSelectedItemData(null);
    }
  }

  updateSelectedItemDataFirebaseUrl() {
    if (this.config)
      setTimeout(() => {
        this.selectedItemDataFirebaseUrl = this.selectedItem
          ? `https://console.firebase.google.com/u/1/project/${this.config.firebaseConfigs[this.config.appName].projectId}/${
              this.get('categoryDetails.firestore') ? 'firestore' : 'database'
            }/data/${this.categoryDataPath}/${this.selectedItem}`
          : '';
      });
  }

  updateTitle() {
    let categoryTitle;
    if (this.category != null && this.categoryDetails != null) {
      categoryTitle = this.categoryDetails.title;
    }
    if (categoryTitle == null) categoryTitle = 'Model Editor';

    // Update selected item title.
    // This part is a little confusing because typically the selected item title will be the title of the selected item (duh).
    // But when we are editing an entire category (not a list item) selected item title will be the category title instead.
    let selectedItemTitle;
    if (this.categoryDetails?.showList) {
      if (this.selectedItem) {
        if (this.creatingItem && this.selectedItem == this.newItemKey) selectedItemTitle = this.newItemName;
        if (this.itemLabel != null) selectedItemTitle = this.itemLabel;
      }
    } else {
      selectedItemTitle = this.categoryDetails?.title;
    }
    this.selectedItemTitle = selectedItemTitle;

    // Update workspace title.
    let workspaceTitle;
    if (this.showCatalog) workspaceTitle = 'Import From Catalog';
    if (this.showImportPla) workspaceTitle = 'Import Pole Loading Catalog';
    if (workspaceTitle == null && this.selectedItemTitle != null && this.showEditor) workspaceTitle = this.selectedItemTitle;
    if (workspaceTitle == null) workspaceTitle = categoryTitle;

    this.workspaceTitle = workspaceTitle;
    this.categoryTitle = categoryTitle;

    let itemTypeTitles = {};
    itemTypeTitles.title = pluralize(this.categoryTitle, 1);
    itemTypeTitles.lowercaseTitle = itemTypeTitles.title.toLowerCase();
    itemTypeTitles.article = ['a', 'e', 'i', 'o', 'u'].includes(itemTypeTitles.lowercaseTitle[0]) ? 'An' : 'A';
    this.itemTypeTitles = itemTypeTitles;
  }

  updateView() {
    // Selected item back button.
    this.showListFilters =
      ['attributes', 'tools', 'photo_elements', 'photo_routines', 'construction_specs'].includes(this.category) && !this.showCatalog;
  }

  updateWorkspaceTitleReadonly() {
    this.workspaceTitleReadonly = this.editingDisabled || this.editor?.computedLabel != null;
  }

  workspaceBackButtonClicked() {
    if (this.showCatalog) {
      this.setShowCatalog(false);
    }
    if (this.showImportPla) {
      this.cancelImportPla();
    }
    if (this.selectedItem != null) {
      this.clearSelectedItem();
    }
  }

  notifyEditability() {
    if (this.editingDisabled) {
      this.itemLabelErrorMessage = "This attributes's name is locked because of its editability settings";
      setTimeout(() => {
        this.itemLabelErrorMessage = false;
      }, 5000);
    }
  }

  itemLabelInputChanged(e) {
    let editor = this.editor;
    if (editor) editor.setLabel(e.currentTarget.value);
  }

  setVisibleFilterTags() {
    const modelTags = (this.showCatalog ? this.catalogData?.tags : this.modelTags) ?? {};
    const noTagsTag = { _id: 'no_tags', name: 'No Tags', icon: 'label_off', color: 'var(--sl-color-neutral-0)' };
    this.allTags = { ...modelTags, ...DEFAULT_TAGS, [noTagsTag._id]: noTagsTag };

    // Preserve the previous checked states of the tags between Polymer updates (does not preserve across category changes).
    const previousCheckedStates = Object.fromEntries(this.visibleFilterTags?.map((tag) => [tag._id, tag.checked]) || []);
    const allTagsArray = Object.entries(this.allTags).map(([_id, tag]) => ({ ...tag, _id, checked: previousCheckedStates[_id] || false }));

    // Identify all tags used by items in the current category.
    const tagsUsedByItems = {};
    this.listItems?.forEach((item) => {
      item.$tags?.forEach((tag) => (tagsUsedByItems[tag] = true));
    });
    const filteredTagsArray = allTagsArray.filter((tag) => tagsUsedByItems[tag._id]);

    // Sort the tags alphabetically by their names.
    const sortedTagsArray = filteredTagsArray.sort((tagA, tagB) => {
      const tagAName = tagA.name;
      const tagBName = tagB.name;
      if (!tagAName || !tagBName) return 0;
      return tagAName.localeCompare(tagBName);
    });
    this.visibleFilterTags = [...sortedTagsArray, Object.assign(noTagsTag, { checked: previousCheckedStates[noTagsTag._id] || false })];
  }

  getCuratedItemTags(item) {
    const itemTags = item.$tags ?? [];

    // filter out item tags that are not currently toggled on with the filter
    const checkedFilterTags = this.visibleFilterTags?.filter((tag) => tag.checked) ?? [];
    const filteredItemTags = itemTags.filter((tagId) => checkedFilterTags.some((tagData) => tagId == tagData._id));

    // Sort item tags by their names
    const curatedItemTags = filteredItemTags.sort((tagIdA, tagIdB) => {
      const tagAName = this.allTags?.[tagIdA]?.name;
      const tagBName = this.allTags?.[tagIdB]?.name;
      if (!tagAName || !tagBName) return 0;
      return tagAName.localeCompare(tagBName);
    });
    return curatedItemTags;
  }

  catalogTagSelectorChanged(e) {
    this.catalogImportTags = e.detail.tags;
  }

  updateFilteredCatalogData() {
    const { categories, catalogData, catalogImportTags = [] } = this;

    if (!catalogData || !catalogImportTags?.length) {
      this.filteredCatalogData = catalogData ?? null;
      return;
    }

    const filteredCatalogData = {};
    categories.forEach((categoryDetails) => {
      const { path: categoryPath, category } = categoryDetails ?? {};
      if (!categoryPath) return;
      // Remove leading 'models/' from the path and split by '/'.
      const categoryPathParts = categoryPath.replace(/^models\//, '').split('/');
      const categoryData = Path.get(catalogData, categoryPathParts.join('.'));
      const categoryTags = getCategoryTags(category, catalogData.category_tags?.[category]);
      if (categoryTags?.length) {
        const hasRelevantTag = catalogImportTags.some((tagId) => categoryTags.includes(tagId));
        if (hasRelevantTag) Path.set(filteredCatalogData, categoryPathParts.join('.'), categoryData);
        return;
      } else {
        Object.entries(categoryData ?? {}).forEach(([itemKey, item]) => {
          const itemTags = getItemTags(category, { ...item, $key: itemKey });
          const hasRelevantTag = catalogImportTags.some((tagId) => itemTags.includes(tagId));
          if (hasRelevantTag) Path.set(filteredCatalogData, [...categoryPathParts, itemKey].join('.'), item);
        });
      }
    });

    this.filteredCatalogData = filteredCatalogData;
  }
}

function getItemTags(category, item) {
  if (!category || !item) return [];

  // The compatible units category uses the "tags" property differently
  const itemTags = (category !== 'compatible_units' ? item.tags : []) ?? [];

  const hardcodedTags = DEFAULT_ITEM_TAG_MAP[category]?.[item.$key] || [];
  return [...new Set([...itemTags, ...hardcodedTags])];
}

function getCategoryTags(category, categoryTags) {
  if (!category || !categoryTags) return [];

  const hardcodedTags = DEFAULT_CATEGORY_TAG_MAP[category] || [];
  const tags = categoryTags || [];
  return [...new Set([...tags, ...hardcodedTags])];
}

customElements.define('katapult-model-editor-workspace', KatapultModelEditorWorkspace);
